/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getTKT1FileUploads, createTKT1FileUpload, updateTKT1FileUpload, deleteTKT1FileUpload, getTKT1ImageAlbums, getTKT1ImageAlbumByMID, updateTKT1ImageAlbum, getTKT1RegisteredEtsyShops } from '../actions';
import ScrollToTop from "react-scroll-to-top";
import Pagination from "../components/Pagination";
import LoadingSpinner from "../components/LoadingSpinner/LoadingSpinner";
import { CONFIGS } from "../configs";
import { getTranslate, LANGUAGE_KEYS } from "../utils";
import queryString from 'query-string';
import {
  Badge,
  Button,
  Card,
  Form,
  Table,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Modal,
  Dropdown
} from "react-bootstrap";
import { FaTimes, FaEye, FaEdit, FaTrash, FaCopy, FaExternalLinkAlt, FaDownload, FaFile, FaFileImage, FaFileVideo, FaFilePdf, FaFileWord, FaFileExcel, FaFilePowerpoint, FaFileArchive, FaFileAlt, FaUpload, FaList, FaTh, FaImage, FaMinus, FaThLarge, FaThList, FaLock, FaChevronLeft, FaChevronRight, FaSortAmountDown, FaSortAmountUp, FaCode } from 'react-icons/fa';
import Select from 'react-select';
import ImageUploadModal from '../components/ImageUploadModal/ImageUploadModal';
import IframeModal from '../components/IframeModal/IframeModal';
import { getApiUrl } from '../utils/platform';
import { API } from '../services/API';
import { getToken } from '../utils/token';
import { toast } from 'react-toastify';

class TKT1FileUploadManagement extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 100,
    sortBy: 'upload_date',
    sortOrder: -1,
    search: '',
    type: '',
    status: '',
    username: ''
  }

  initShowColumns = {
    list: {
    original_filename: true,
      filename: true,
    type: true,
    file_size: true,
    mime_type: true,
    username: true,
    upload_date: true,
    upload_method: true,
    status: true,
    is_public: true,
    bucket_name: true,
    file_url: true,
      thumbnail_url: true,
    ref_id: true,
    ref_type: true,
    metadata: true,
    note: true,
    _id: false
    },
    grid: {
      original_filename: true,
      filename: true,
      type: true,
      file_size: true,
      username: true,
      upload_date: true,
      status: true,
      is_public: true,
      thumbnail_url: true,
    note: true,
    _id: false
    }
  }

  constructor() {
    super();
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns,
      loading: false,
      showConfigModal: false,
      showViewModal: false,
      showEditModal: false,
      showUploadModal: false,
      showImageModal: false,
      selectedFileUpload: null,
      selectedImageUrl: '',
      selectedImageName: '',
      selectedImageIndex: 0, // Index of currently selected image
      fastMode: false,
      isEditMode: false,
      uploadingFiles: false,
      uploadProgress: {
        current: 0,
        total: 0,
        currentFileName: '',
        isUploading: false
      },
      uploadIsPublic: JSON.parse(localStorage.getItem('tkt1_upload_is_public') || 'false'),
      createThumbnail: true,
      selectedFiles: [], // For upload functionality
      filePreviews: [],
      uploadNote: '',
      customFilenames: {},
      viewMode: 'grid', // 'list' or 'grid'
      configMode: 'grid', // 'list' or 'grid' - for config modal
      gridSize: 6, // 4 or 6 items per row in grid mode
      selectedFileIds: [], // Array of selected file IDs for multiple actions
      selectAll: false,
      multipleMode: false, // Toggle for multiple selection mode
      showAlbumSelectModal: false,
      albumMidInput: '',
      showAllAlbumsModal: false,
      currentAlbumInfo: null, // Store current album info for title
      loadingAlbumInfo: false, // Loading state for album info
      isDragOver: false, // For drag and drop functionality
      showAlbumEditModal: false, // For album edit modal
      selectedAlbum: null, // Selected album for editing
      editFormData: {
        status: 'UPLOADED',
        is_public: false,
        ref_id: '',
        ref_type: '',
        metadata: '',
        note: '',
        filename: ''
      },
      albumEditFormData: {
        mid: '',
        name: '',
        description: '',
        cover_url: '',
        type: 'OTHER_PUBLIC',
        status: 'ACTIVE',
        note: '',
        username: '',
        tags: [],
        original_listing_id: '',
        posted_listing_id: '',
        registered_shop_mid: ''
      },
      svgSourceFile: null,
      showSVGSourceModal: false,
      currentSVGContent: '',
    };
  }

  componentDidMount() {
    const routeType = this.getRouteType();
    const albumMid = this.getAlbumMid();
    const titleMap = {
      'all': 'TKT1 File Upload Management - All',
      'IMAGE': 'TKT1 File Upload Management - Image',
      'VIDEO': 'TKT1 File Upload Management - Video',
      'PDF': 'TKT1 File Upload Management - PDF',
      'DOC': 'TKT1 File Upload Management - Document',
      'OTHER': 'TKT1 File Upload Management - Other',
      'ALBUM': `Album #${albumMid}` // Will be updated when album info is loaded
    };
    document.title = titleMap[routeType] || 'TKT1 File Upload Management';
    
    // Add keyboard event listener for image modal navigation
    document.addEventListener('keydown', this.handleKeyDown);
    const queryStringFromUrl = window.location.search;
    const urlParams = new URLSearchParams(queryStringFromUrl);
    
    // Check if URL has any query parameters
    const hasUrlParams = queryStringFromUrl && queryStringFromUrl.length > 1;
    
    // Load view mode for this specific route
    const viewModeKey = `tkt1_file_upload_view_mode_${routeType}`;
    const savedViewMode = localStorage.getItem(viewModeKey) || 'grid';
    
    // Load grid size for this specific route
    const gridSizeKey = `tkt1_file_upload_grid_size_${routeType}`;
    const savedGridSize = parseInt(localStorage.getItem(gridSizeKey)) || 6;
    
    if (hasUrlParams) {
      // URL has query parameters - override localStorage
      const queryObject = queryString.parse(queryStringFromUrl);
      
      // Parse numeric values
      ['itemsPerPage', 'currentPage'].map(key => {
        if (queryObject[key]) {
          queryObject[key] = parseInt(queryObject[key])
        }
      })
      if (queryObject.sortOrder) {
        queryObject.sortOrder = parseInt(queryObject.sortOrder);
      }
      
      // Load showColumns separately from view config
      const viewConfig = JSON.parse(localStorage.getItem('TKT1FileUploadManagement_ViewConfig'));
      
      const restoredQuery = {
        ...this.initQuery,
        ...queryObject
      };

      // Override type based on route if not 'all' and not 'ALBUM' (album shows all types)
      if (routeType !== 'all' && routeType !== 'ALBUM') {
        restoredQuery.type = routeType;
      }

      // Handle album filter - only for album route
      if (routeType === 'ALBUM' && albumMid) {
        restoredQuery.belong_to_albums = albumMid;
        // Set default sort for album route: upload_date, ascending
        if (!restoredQuery.sortBy) {
          restoredQuery.sortBy = 'upload_date';
        }
        if (!restoredQuery.sortOrder) {
          restoredQuery.sortOrder = 1; // ascending
        }
      } else {
        // Remove belong_to_albums for non-album routes
        delete restoredQuery.belong_to_albums;
      }

      this.setState({
        query: restoredQuery,
        showColumns: {
          list: {
            ...this.initShowColumns.list,
            ...(viewConfig?.list || {})
          },
          grid: {
            ...this.initShowColumns.grid,
            ...(viewConfig?.grid || {})
          }
        },
        viewMode: savedViewMode,
        gridSize: savedGridSize
        }, () => {
          const currentUrl = window.location.href;
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1FileUploads(apiQuery, currentUrl);
        })
    } else {
      // No URL params - use localStorage
      const queryKey = `tkt1_file_upload_management_query_${routeType}`;
      var query = JSON.parse(localStorage.getItem(queryKey));
      var viewConfig = JSON.parse(localStorage.getItem('TKT1FileUploadManagement_ViewConfig'));
      
      if (query) {
        const restored = {
          ...this.initQuery,
          ...query
        };
        restored.itemsPerPage = parseInt(restored.itemsPerPage || this.initQuery.itemsPerPage);
        restored.currentPage = parseInt(restored.currentPage || this.initQuery.currentPage);
        restored.sortOrder = parseInt(restored.sortOrder || this.initQuery.sortOrder);

        // Override type based on route if not 'all' and not 'ALBUM' (album shows all types)
        if (routeType !== 'all' && routeType !== 'ALBUM') {
          restored.type = routeType;
        }

        // Handle album filter - only for album route
        if (routeType === 'ALBUM' && albumMid) {
          restored.belong_to_albums = albumMid;
          // Set default sort for album route: upload_date, ascending
          if (!restored.sortBy) {
            restored.sortBy = 'upload_date';
          }
          if (!restored.sortOrder) {
            restored.sortOrder = 1; // ascending
          }
        } else {
          // Remove belong_to_albums for non-album routes
          delete restored.belong_to_albums;
        }

        this.setState({
          query: restored,
          showColumns: {
            list: {
              ...this.initShowColumns.list,
              ...(viewConfig?.list || {})
            },
            grid: {
              ...this.initShowColumns.grid,
              ...(viewConfig?.grid || {})
            }
          },
          viewMode: savedViewMode,
          gridSize: savedGridSize
        }, () => {
          const currentUrl = window.location.href;
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1FileUploads(apiQuery, currentUrl);
        })
      } else {
        const initialQuery = { ...this.initQuery };
        
        // Override type based on route if not 'all' and not 'ALBUM' (album shows all types)
        if (routeType !== 'all' && routeType !== 'ALBUM') {
          initialQuery.type = routeType;
        }

        // Handle album filter - only for album route
        if (routeType === 'ALBUM' && albumMid) {
          initialQuery.belong_to_albums = albumMid;
          // Set default sort for album route: upload_date, ascending
          initialQuery.sortBy = 'upload_date';
          initialQuery.sortOrder = 1; // ascending
        } else {
          // Remove belong_to_albums for non-album routes
          delete initialQuery.belong_to_albums;
        }

        this.setState({
          query: initialQuery,
          showColumns: {
            list: {
              ...this.initShowColumns.list,
              ...(viewConfig?.list || {})
            },
            grid: {
              ...this.initShowColumns.grid,
              ...(viewConfig?.grid || {})
            }
          },
          viewMode: savedViewMode,
          gridSize: savedGridSize
        }, () => {
          const currentUrl = window.location.href;
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1FileUploads(apiQuery, currentUrl);
        })
      }
    }
    
    // Clear old album info and load new one if in album route
    this.handleRouteChange();
    
    // Load registered shops data for shop name mapping
    this.loadRegisteredShops();
    
    // Load Fast Mode setting from localStorage
    this.loadFastModeSetting();
    
  }

  componentWillUnmount() {
    // Remove keyboard event listener
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  componentDidUpdate(prevProps) {
    // Load current album info when albums are loaded
    if (prevProps.albums !== this.props.albums && this.getRouteType() === 'ALBUM' && this.state.loadingAlbumInfo) {
      const albumMid = this.getAlbumMid();
      const albums = this.props.albums || [];
      const currentAlbum = albums.find(album => album.mid === albumMid);
      
      if (currentAlbum) {
        // Keep full album data including metadata
        this.setState({ 
          currentAlbumInfo: currentAlbum,
          loadingAlbumInfo: false 
        });
        // Update document title
        document.title = `Album ${currentAlbum.name} (#${albumMid})`;
      } else {
        this.setState({ loadingAlbumInfo: false });
      }
    }
  }

  // Get route type from URL path
  getRouteType = () => {
    const path = window.location.pathname;
    // Check ORNAMENT routes first
    if (path === '/admin/rnd/ornament/shape' || path.endsWith('/rnd/ornament/shape')) return 'ONM_SHAPE';
    if (path === '/admin/rnd/ornament/object' || path.endsWith('/rnd/ornament/object')) return 'ONM_OBJECT';
    if (path === '/admin/rnd/ornament/image' || path.endsWith('/rnd/ornament/image')) return 'ONM_IMAGE';
    if (path.includes('/upload-management/image')) return 'IMAGE';
    if (path.includes('/upload-management/video')) return 'VIDEO';
    if (path.includes('/upload-management/pdf')) return 'PDF';
    if (path.includes('/upload-management/doc')) return 'DOC';
    if (path.includes('/upload-management/other')) return 'OTHER';
    if (path.includes('/upload-management/all')) return 'all';
    if (path.includes('/album-detail/')) return 'ALBUM';
    return 'all'; // default
  }

  // Get album MID from URL path
  getAlbumMid = () => {
    const path = window.location.pathname;
    const match = path.match(/\/album-detail\/([^\/]+)/);
    return match ? match[1] : null;
  }

  getAlbumTypeLink = () => {
    if (this.state.currentAlbumInfo && this.state.currentAlbumInfo.type) {
      const type = this.state.currentAlbumInfo.type;
      // Map album types to their corresponding routes
      const typeRouteMap = {
        'LISTING': 'listing',
        'AVATAR': 'avatar', 
        'C3D': 'c3d',
        'SCAN_PERSON': 'scan-person',
        'BACKGROUND': 'background',
        'DECORATING': 'decorating',
        'OTHER_PUBLIC': 'other-public',
        'OTHER_PRIVATE': 'other-private'
      };
      
      const route = typeRouteMap[type] || 'all';
      return `/admin/tkt1-media/album/${route}`;
    }
    return '/admin/tkt1-media/album';
  }

  // Determine if upload should be public based on album type or route type
  shouldUploadBePublic = () => {
    // Check route type first (for ornament routes)
    const routeType = this.getRouteType();
    const ornamentRoutes = ['ONM_SHAPE', 'ONM_OBJECT', 'ONM_IMAGE'];
    if (ornamentRoutes.includes(routeType)) {
      return true; // Always public for ornament routes
    }
    
    // Check album type
    const albumType = this.state.currentAlbumInfo?.type;
    const publicTypes = [
      'LISTING', 'BACKGROUND', 'DECORATING', 'AVATAR', 'OTHER_PUBLIC',
      'ONM_SHAPE', 'ONM_OBJECT', 'ONM_IMAGE'
    ];
    return publicTypes.includes(albumType);
  }

  // Check if upload type selection should be shown
  shouldShowUploadTypeSelection = () => {
    const albumType = this.state.currentAlbumInfo?.type;
    // Hide selection for all album types - let the system decide automatically
    return false;
  }

  getShopNameFromMid = (shopMid) => {
    if (!shopMid || !this.props.registeredEtsyShops) return shopMid;
    
    const shop = this.props.registeredEtsyShops.find(s => s.MID === shopMid);
    return shop?.trusted_story_info?.etsy_shop_name || shopMid;
  }

  getRegisteredShopOptions = () => {
    return this.props.registeredEtsyShops ? this.props.registeredEtsyShops.map((shop) => ({
      value: shop.MID,
      label: `${shop.MID} - ${shop.trusted_story_info?.etsy_shop_name || shop.shop_id || 'N/A'}`
    })) : [];
  }

  loadRegisteredShops = async () => {
    try {
      // Load registered shops data for dropdown
      const query = { currentPage: 1, itemsPerPage: 1000, sortBy: 'MID', sortOrder: 1 };
      await this.props.getTKT1RegisteredEtsyShops(query);
    } catch (error) {
      console.error('Error loading registered shops:', error);
    }
  }

  loadFastModeSetting = () => {
    try {
      const savedFastMode = localStorage.getItem('tkt1_file_upload_fast_mode');
      if (savedFastMode !== null) {
        const fastMode = JSON.parse(savedFastMode);
        this.setState({ fastMode });
      }
    } catch (error) {
      console.error('Error loading Fast Mode setting:', error);
    }
  }

  // Check if we should show type filter
  shouldShowTypeFilter = () => {
    const routeType = this.getRouteType();
    return routeType === 'all' || routeType === 'ALBUM';
  }

  loadData = () => {
    const apiQuery = this.prepareApiQuery(this.state.query);
    const currentUrl = window.location.href;
    this.props.getTKT1FileUploads(apiQuery, currentUrl);
  }


  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    })
  }

  handleClearSearch = () => {
    this.setState({
      query: { ...this.state.query, search: '' }
    }, () => {
      this.handleSearch();
    })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleTypeChange = (e) => {
    const newQuery = { ...this.state.query, type: e.target.value };
    this.setState({ query: newQuery });
    
    // Save query to localStorage based on route type
    const routeType = this.getRouteType();
    const queryKey = `tkt1_file_upload_management_query_${routeType}`;
    localStorage.setItem(queryKey, JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    this.updateUrl(newQuery);
    this.loadData();
  }

  handleStatusChange = (e) => {
    const newQuery = { ...this.state.query, status: e.target.value };
    this.setState({ query: newQuery });
    
    // Save query to localStorage based on route type
    const routeType = this.getRouteType();
    const queryKey = `tkt1_file_upload_management_query_${routeType}`;
    localStorage.setItem(queryKey, JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    this.updateUrl(newQuery);
    this.loadData();
  }

  handleUsernameChange = (e) => {
    const newQuery = { ...this.state.query, username: e.target.value };
    this.setState({ query: newQuery });
    
    // Save query to localStorage based on route type
    const routeType = this.getRouteType();
    const queryKey = `tkt1_file_upload_management_query_${routeType}`;
    localStorage.setItem(queryKey, JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    this.updateUrl(newQuery);
    this.loadData();
  }


  handleSelectSort = (e) => {
    const newQuery = { ...this.state.query, sortBy: e.target.value };
    this.setState({ query: newQuery });
    
    // Save query to localStorage based on route type
    const routeType = this.getRouteType();
    const queryKey = `tkt1_file_upload_management_query_${routeType}`;
    localStorage.setItem(queryKey, JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    this.updateUrl(newQuery);
    this.loadData();
  }

  handleSelectSortOrder = (e) => {
    const newQuery = { ...this.state.query, sortOrder: parseInt(e.target.value) };
    this.setState({ query: newQuery });
    
    // Save query to localStorage based on route type
    const routeType = this.getRouteType();
    const queryKey = `tkt1_file_upload_management_query_${routeType}`;
    localStorage.setItem(queryKey, JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    this.updateUrl(newQuery);
    this.loadData();
  }

  handleColumnToggle = (columnKey) => {
    this.setState(prevState => {
      const currentMode = this.state.configMode;
      const newShowColumns = {
        ...prevState.showColumns,
        [currentMode]: {
          ...prevState.showColumns[currentMode],
          [columnKey]: !prevState.showColumns[currentMode][columnKey]
        }
      };
      
      // Save view config to localStorage
      localStorage.setItem('TKT1FileUploadManagement_ViewConfig', JSON.stringify(newShowColumns));
      
      return { showColumns: newShowColumns };
    })
  }

  handleViewModeToggle = (mode) => {
    const routeType = this.getRouteType();
    const viewModeKey = `tkt1_file_upload_view_mode_${routeType}`;
    
    this.setState({ viewMode: mode });
    localStorage.setItem(viewModeKey, mode);
  }

  handleGridSizeToggle = (size) => {
    const routeType = this.getRouteType();
    const gridSizeKey = `tkt1_file_upload_grid_size_${routeType}`;
    
    this.setState({ gridSize: size });
    localStorage.setItem(gridSizeKey, size.toString());
  }

  // Multiple selection handlers
  handleSelectAll = () => {
    const { fileUploads } = this.props;
    const allFileIds = fileUploads.map(file => file._id);
    this.setState({ 
      selectedFileIds: allFileIds,
      selectAll: true 
    });
  }

  handleDeselectAll = () => {
    this.setState({ 
      selectedFileIds: [],
      selectAll: false 
    });
  }

  // Toggle multiple selection mode
  handleMultipleModeToggle = () => {
    const newMultipleMode = !this.state.multipleMode;
    this.setState({
      multipleMode: newMultipleMode,
      selectedFileIds: newMultipleMode ? [] : this.state.selectedFileIds,
      selectAll: false
    });
  }

  handleFileSelectForMultiple = (fileId) => {
    this.setState(prevState => {
      const isSelected = prevState.selectedFileIds.includes(fileId);
      let newSelectedIds;
      
      if (isSelected) {
        newSelectedIds = prevState.selectedFileIds.filter(id => id !== fileId);
      } else {
        newSelectedIds = [...prevState.selectedFileIds, fileId];
      }
      
      const { fileUploads } = this.props;
      const selectAll = newSelectedIds.length === fileUploads.length;
      
      return {
        selectedFileIds: newSelectedIds,
        selectAll: selectAll
      };
    });
  }

  handleAddToAlbum = () => {
    // Load available albums
    // TEMPORARILY DISABLED: this.props.getTKT1ImageAlbums({ currentPage: 1, itemsPerPage: 1000 });
    this.setState({ showAlbumSelectModal: true });
  }

  handleRemoveFromCurrentAlbum = async () => {
    const { selectedFileIds } = this.state;
    const { fileUploads } = this.props;
    
    if (selectedFileIds.length === 0) {
      toast.error('Vui lòng chọn ít nhất một file');
      return;
    }

    if (!window.confirm(`Bạn có chắc chắn muốn xóa ${selectedFileIds.length} file khỏi album hiện tại?`)) {
      return;
    }

    try {
      // Get selected files
      const selectedFiles = fileUploads.filter(file => selectedFileIds.includes(file._id));
      
      // Update each file's metadata to remove from current album
      for (const file of selectedFiles) {
        const currentMetadata = file.metadata || {};
        const currentAlbums = currentMetadata.belong_to_albums || '';
        const currentAlbumMid = this.getAlbumMid();
        
        // Parse existing albums and remove current album
        const existingAlbums = currentAlbums ? currentAlbums.split(',').map(mid => mid.trim()) : [];
        const updatedAlbums = existingAlbums.filter(mid => mid !== currentAlbumMid);
        
        // Update metadata
        const updatedMetadata = {
          ...currentMetadata,
          belong_to_albums: updatedAlbums.join(',')
        };
        
        // Update file
        await this.props.updateTKT1FileUpload(file._id, {
          metadata: updatedMetadata
        });
      }
      
      // Clear selection
      this.setState({ 
        selectedFileIds: [],
        selectAll: false 
      });
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1FileUploads(apiQuery, window.location.href);
      
      toast.success(`Đã xóa ${selectedFileIds.length} file khỏi album hiện tại`);
    } catch (error) {
      console.error('Error removing files from album:', error);
      toast.error('Lỗi khi xóa files khỏi album. Vui lòng thử lại.');
    }
  }

  handleDeleteSelectedFiles = async () => {
    const { selectedFileIds } = this.state;
    
    if (selectedFileIds.length === 0) {
      toast.error('Vui lòng chọn ít nhất một file');
      return;
    }

    if (!window.confirm(`Bạn có chắc chắn muốn xóa ${selectedFileIds.length} file đã chọn?`)) {
      return;
    }

    try {
      // Delete each selected file
      for (const fileId of selectedFileIds) {
        await this.props.deleteTKT1FileUpload(fileId);
      }
      
      // Clear selection
      this.setState({ 
        selectedFileIds: [],
        selectAll: false 
      });
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1FileUploads(apiQuery, window.location.href);
      
      toast.success(`Đã xóa ${selectedFileIds.length} file thành công`);
    } catch (error) {
      console.error('Error deleting selected files:', error);
      toast.error('Lỗi khi xóa files. Vui lòng thử lại.');
    }
  }

  handleCloseAlbumSelectModal = () => {
    this.setState({ 
      showAlbumSelectModal: false,
      albumMidInput: ''
    });
  }

  handleOpenAllAlbumsModal = () => {
    this.setState({ showAllAlbumsModal: true });
  }

  handleCloseAllAlbumsModal = () => {
    this.setState({ showAllAlbumsModal: false });
  }

  handleOpenFullScreen = () => {
    const albumMid = this.getAlbumMid();
    if (albumMid) {
      window.open(`/admin/tkt1-media/album-detail/${albumMid}`, '_blank');
    }
  }


  handleEditCurrentAlbum = () => {
    if (this.state.currentAlbumInfo) {
      // Open edit modal for current album
      this.setState({
        showAlbumEditModal: true,
        selectedAlbum: this.state.currentAlbumInfo,
        isEditMode: true,
        albumEditFormData: {
          mid: this.state.currentAlbumInfo.mid || '',
          name: this.state.currentAlbumInfo.name || '',
          description: this.state.currentAlbumInfo.description || '',
          cover_url: this.state.currentAlbumInfo.cover_url || '',
          type: this.state.currentAlbumInfo.type || 'OTHER_PUBLIC',
          status: this.state.currentAlbumInfo.status || 'ACTIVE',
          note: this.state.currentAlbumInfo.note || '',
          username: this.state.currentAlbumInfo.username || '',
          tags: this.state.currentAlbumInfo.tags || [],
          original_listing_id: this.state.currentAlbumInfo.metadata?.original_listing_id || '',
          posted_listing_id: this.state.currentAlbumInfo.metadata?.posted_listing_id || '',
          registered_shop_mid: this.state.currentAlbumInfo.metadata?.registered_shop_mid || ''
        }
      });
    } else {
      toast.error('Không tìm thấy thông tin album để chỉnh sửa');
    }
  }

  handleCloseAlbumEditModal = () => {
    this.setState({
      showAlbumEditModal: false,
      selectedAlbum: null,
      isEditMode: false,
      albumEditFormData: {
        mid: '',
        name: '',
        description: '',
        cover_url: '',
        type: 'OTHER_PUBLIC',
        status: 'ACTIVE',
        note: '',
        username: '',
        tags: [],
        original_listing_id: '',
        posted_listing_id: '',
        registered_shop_mid: ''
      }
    });
  }

  handleAlbumEditInputChange = (field, value) => {
    const newAlbumEditFormData = {
      ...this.state.albumEditFormData,
      [field]: value
    };
    
    // Auto-set status to PUBLISHED when posted_listing_id has value
    if (field === 'posted_listing_id' && value && value.trim() !== '') {
      newAlbumEditFormData.status = 'PUBLISHED';
    }
    
    this.setState({
      albumEditFormData: newAlbumEditFormData
    });
  }

  handleSaveAlbumEdit = async () => {
    const { selectedAlbum, albumEditFormData } = this.state;
    
    if (!selectedAlbum || !selectedAlbum._id) {
      toast.error('Không tìm thấy thông tin Album để cập nhật');
      return;
    }

    try {
      // Prepare data without MID and username (they shouldn't be updated)
      const { mid, username, original_listing_id, posted_listing_id, registered_shop_mid, ...updateData } = albumEditFormData;
      
      // Add original_listing_id, posted_listing_id and registered_shop_mid to metadata
      const metadata = {
        ...(updateData.metadata || {}),
        original_listing_id: original_listing_id,
        posted_listing_id: posted_listing_id,
        registered_shop_mid: registered_shop_mid
      };
      
      // Add metadata to updateData
      updateData.metadata = metadata;
      
      // Call update action
      await this.props.updateTKT1ImageAlbum(selectedAlbum._id, updateData);
      
      // Update current album info
      this.setState({
        currentAlbumInfo: {
          ...this.state.currentAlbumInfo,
          ...updateData,
          metadata: {
            ...this.state.currentAlbumInfo.metadata,
            original_listing_id: original_listing_id,
            posted_listing_id: posted_listing_id,
            registered_shop_mid: registered_shop_mid
          }
        }
      });
      
      // Close modal
      this.handleCloseAlbumEditModal();
      
      toast.success('Cập nhật thông tin Album thành công!');
    } catch (error) {
      console.error('Error updating album:', error);
      toast.error('Lỗi khi cập nhật thông tin Album. Vui lòng thử lại.');
    }
  }

  // Drag and drop handlers
  handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isDragOver: true });
  }

  handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isDragOver: false });
  }

  handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isDragOver: false });

    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) {
      this.handleFileSelect({ target: { files } });
      this.setState({ showUploadModal: true });
    }
  }

  // Handle route change - clear old album info and load new one
  handleRouteChange = () => {
    const routeType = this.getRouteType();
    if (routeType === 'ALBUM') {
      // Clear old album info immediately when navigating to album route
      this.setState({ 
        currentAlbumInfo: null,
        loadingAlbumInfo: true 
      });
      // Load new album info
      this.loadCurrentAlbumInfo();
    }
  }

  // Load current album info for title
  loadCurrentAlbumInfo = async () => {
    const routeType = this.getRouteType();
    const albumMid = this.getAlbumMid();
    
    console.log('TKT1FileUploadManagement - loadCurrentAlbumInfo Debug:', {
      routeType,
      albumMid,
      currentPath: window.location.pathname
    });
    
    if (routeType === 'ALBUM' && albumMid) {
      try {
        console.log('TKT1FileUploadManagement - Loading album with MID:', albumMid);
        // Load specific album by MID
        const response = await this.props.getTKT1ImageAlbumByMID(albumMid);
        
        console.log('TKT1FileUploadManagement - API Response:', response);
        
        if (response && response.data && response.data.data) {
          console.log('TKT1FileUploadManagement - Setting album info:', response.data.data);
          this.setState({ 
            currentAlbumInfo: response.data.data,
            loadingAlbumInfo: false 
          });
        } else if (response && response.data) {
          console.log('TKT1FileUploadManagement - Setting album info (direct data):', response.data);
          this.setState({ 
            currentAlbumInfo: response.data,
            loadingAlbumInfo: false 
          });
        } else {
          console.log('TKT1FileUploadManagement - No album data found');
          this.setState({ loadingAlbumInfo: false });
        }
      } catch (error) {
        console.error('TKT1FileUploadManagement - Error loading album info:', error);
        this.setState({ loadingAlbumInfo: false });
      }
    } else {
      console.log('TKT1FileUploadManagement - Not loading album info:', { routeType, albumMid });
    }
  }

  handleAddFilesToAlbum = async (albumMid) => {
    const { selectedFileIds } = this.state;
    const { fileUploads } = this.props;
    
    if (selectedFileIds.length === 0) {
      toast.error('Vui lòng chọn ít nhất một file');
      return;
    }

    try {
      // Get selected files
      const selectedFiles = fileUploads.filter(file => selectedFileIds.includes(file._id));
      
      // Update each file's metadata
      for (const file of selectedFiles) {
        const currentMetadata = file.metadata || {};
        const currentAlbums = currentMetadata.belong_to_albums || '';
        
        // Parse existing albums
        const existingAlbums = currentAlbums ? currentAlbums.split(',').map(mid => mid.trim()) : [];
        
        // Add new album if not already present
        if (!existingAlbums.includes(albumMid)) {
          existingAlbums.push(albumMid);
        }
        
        // Update metadata
        const updatedMetadata = {
          ...currentMetadata,
          belong_to_albums: existingAlbums.join(',')
        };
        
        // Update file
        await this.props.updateTKT1FileUpload(file._id, {
          metadata: updatedMetadata
        });
      }
      
      // Clear selection
      this.setState({ 
        selectedFileIds: [],
        selectAll: false 
      });
      
      // Close modal
      this.handleCloseAlbumSelectModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1FileUploads(apiQuery, window.location.href);
      
      toast.success(`Đã thêm ${selectedFileIds.length} file(s) vào album ${albumMid}`);
    } catch (error) {
      console.error('Error adding files to album:', error);
      toast.error('Lỗi khi thêm files vào album. Vui lòng thử lại.');
    }
  }

  // Remove file from current album
  handleRemoveFromAlbum = async (fileUpload) => {
    const albumMid = this.getAlbumMid();
    
    if (!albumMid) {
      toast.error('Không tìm thấy thông tin album');
      return;
    }

    if (window.confirm(`Bạn có chắc chắn muốn xóa file "${fileUpload.filename || fileUpload.original_filename}" khỏi album ${albumMid}?`)) {
      try {
        const currentMetadata = fileUpload.metadata || {};
        const currentAlbums = currentMetadata.belong_to_albums || '';
        
        // Parse existing albums
        const existingAlbums = currentAlbums ? currentAlbums.split(',').map(mid => mid.trim()) : [];
        
        // Remove current album
        const updatedAlbums = existingAlbums.filter(mid => mid !== albumMid);
        
        // Update metadata
        const updatedMetadata = {
          ...currentMetadata,
          belong_to_albums: updatedAlbums.join(',')
        };
        
        // Update file
        await this.props.updateTKT1FileUpload(fileUpload._id, {
          metadata: updatedMetadata
        });
        
        // Refresh data
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1FileUploads(apiQuery, window.location.href);
        
        toast.success(`Đã xóa file khỏi album ${albumMid}`);
      } catch (error) {
        console.error('Error removing file from album:', error);
        toast.error('Lỗi khi xóa file khỏi album. Vui lòng thử lại.');
      }
    }
  }

  // Set file as album cover
  handleSetAsAlbumCover = async (fileUpload) => {
    const albumMid = this.getAlbumMid();
    
    if (!albumMid) {
      toast.error('Không tìm thấy thông tin album');
      return;
    }

    if (!this.isImageFile(fileUpload.type, fileUpload.mime_type)) {
      toast.error('Chỉ có thể đặt file hình ảnh làm ảnh nền album');
      return;
    }

    if (window.confirm(`Bạn có chắc chắn muốn đặt file "${fileUpload.filename || fileUpload.original_filename}" làm ảnh nền cho album ${albumMid}?`)) {
      try {
        // Get album info first - try from props first, then load if needed
        let currentAlbum = null;
        const albums = this.props.albums || [];
        currentAlbum = albums.find(album => album.mid === albumMid);
        
        // If not found in props, load album info
        if (!currentAlbum) {
          console.log('Album not found in props, loading album info...');
          // Load albums to get the current album info
          // TEMPORARILY DISABLED: await this.props.getTKT1ImageAlbums({ currentPage: 1, itemsPerPage: 1000 });
          
          // Try again after loading
          const updatedAlbums = this.props.albums || [];
          currentAlbum = updatedAlbums.find(album => album.mid === albumMid);
        }
        
        if (!currentAlbum) {
          toast.error('Không tìm thấy thông tin album');
          return;
        }

        // Update album cover - use original for SVG files, otherwise use thumbnail if available
        const coverUrl = this.isSvgFile(fileUpload.type, fileUpload.mime_type, fileUpload.original_filename) ?
          this.getFileUrl(fileUpload.s3_key, fileUpload.is_public) :
          (fileUpload.thumbnail_s3_key ? 
            this.getThumbnailUrl(fileUpload.thumbnail_s3_key, fileUpload.is_public) : 
            this.getFileUrl(fileUpload.s3_key, fileUpload.is_public));
        console.log('Setting album cover:', { albumId: currentAlbum._id, coverUrl });
        
        await this.props.updateTKT1ImageAlbum(currentAlbum._id, {
          cover_url: coverUrl
        });
        
        toast.success(`Đã đặt file làm ảnh nền cho album ${albumMid}`);
      } catch (error) {
        console.error('Error setting album cover:', error);
        toast.error('Lỗi khi đặt ảnh nền album. Vui lòng thử lại.');
      }
    }
  }

  // Map status to Vietnamese
  mapStatus = (status) => {
    if (!status) return '-';
    switch (status.toUpperCase()) {
      case 'UPLOADING':
        return 'Đang tải lên';
      case 'UPLOADED':
        return 'Đã tải lên';
      case 'PROCESSING':
        return 'Đang xử lý';
      case 'PROCESSED':
        return 'Đã xử lý';
      case 'FAILED':
        return 'Thất bại';
      case 'DELETED':
        return 'Đã xóa';
      default:
        return status;
    }
  }

  // Map type to Vietnamese
  mapType = (type) => {
    if (!type) return '-';
    switch (type.toUpperCase()) {
      case 'IMAGE':
        return 'Hình ảnh';
      case 'VIDEO':
        return 'Video';
      case 'PDF':
        return 'PDF';
      case 'DOC':
        return 'Tài liệu';
      case 'DOCX':
        return 'Tài liệu';
      case 'TXT':
        return 'Văn bản';
      case 'JSON':
        return 'JSON';
      case 'CSV':
        return 'CSV';
      case 'XLS':
        return 'Bảng tính';
      case 'XLSX':
        return 'Bảng tính';
      case 'PPT':
        return 'Trình bày';
      case 'PPTX':
        return 'Trình bày';
      case 'ZIP':
        return 'Nén';
      case 'RAR':
        return 'Nén';
      case 'OTHER':
        return 'Khác';
      default:
        return type;
    }
  }

  // Get file icon based on type
  getFileIcon = (type) => {
    switch (type?.toUpperCase()) {
      case 'IMAGE':
        return <FaFileImage className="text-primary" />;
      case 'VIDEO':
        return <FaFileVideo className="text-danger" />;
      case 'PDF':
        return <FaFilePdf className="text-danger" />;
      case 'DOC':
      case 'DOCX':
        return <FaFileWord className="text-primary" />;
      case 'XLS':
      case 'XLSX':
        return <FaFileExcel className="text-success" />;
      case 'PPT':
      case 'PPTX':
        return <FaFilePowerpoint className="text-warning" />;
      case 'ZIP':
      case 'RAR':
        return <FaFileArchive className="text-secondary" />;
      case 'TXT':
      case 'JSON':
      case 'CSV':
        return <FaFileAlt className="text-info" />;
      default:
        return <FaFile className="text-muted" />;
    }
  }

  // Format file size
  formatFileSize = (bytes) => {
    if (!bytes) return '-';
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    if (bytes === 0) return '0 Bytes';
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
  }

  // Copy text to clipboard
  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied to clipboard:', text);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  // Modal handlers
  handleViewClick = (fileUpload) => {
    this.setState({
      showViewModal: true,
      selectedFileUpload: fileUpload,
      isEditMode: false
    });
  }

  handleEditClick = (fileUpload) => {
    this.setState({
      showEditModal: true,
      selectedFileUpload: fileUpload,
      isEditMode: true,
      editFormData: {
        status: fileUpload.status || 'UPLOADED',
        is_public: fileUpload.is_public || false,
        ref_id: fileUpload.ref_id || '',
        ref_type: fileUpload.ref_type || '',
        metadata: fileUpload.metadata ? JSON.stringify(fileUpload.metadata, null, 2) : '',
        note: fileUpload.note || '',
        filename: fileUpload.filename || ''
      }
    });
  }

  handleCloseViewModal = () => {
    this.setState({
      showViewModal: false,
      selectedFileUpload: null,
      isEditMode: false
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedFileUpload: null,
      isEditMode: false,
      editFormData: {
        status: 'UPLOADED',
        is_public: false,
        ref_id: '',
        ref_type: '',
        metadata: '',
        note: '',
        filename: ''
      }
    });
  }

  handleEditInputChange = (field, value) => {
    this.setState({
      editFormData: {
        ...this.state.editFormData,
        [field]: value
      }
    });
  }

  handleSaveEdit = async () => {
    const { selectedFileUpload, editFormData } = this.state;
    
    if (!selectedFileUpload || !selectedFileUpload._id) {
      toast.error('Không tìm thấy thông tin File Upload để cập nhật');
      return;
    }

    try {
      // Parse metadata JSON if provided
      let parsedMetadata = null;
      if (editFormData.metadata && editFormData.metadata.trim()) {
        try {
          parsedMetadata = JSON.parse(editFormData.metadata);
        } catch (error) {
          toast.error('Metadata không đúng định dạng JSON. Vui lòng kiểm tra lại.');
          return;
        }
      }

      // Prepare update data
      const updateData = {
        ...editFormData,
        metadata: parsedMetadata
      };

      // Call update action
      await this.props.updateTKT1FileUpload(selectedFileUpload._id, updateData);
      
      // Close modal
      this.handleCloseEditModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1FileUploads(apiQuery, window.location.href);
      
      toast.success('Cập nhật thông tin File Upload thành công!');
    } catch (error) {
      console.error('Error updating file upload:', error);
      toast.error('Lỗi khi cập nhật thông tin File Upload. Vui lòng thử lại.');
    }
  }

  handleDeleteClick = async (fileUpload) => {
    if (window.confirm('Bạn có chắc chắn muốn xóa file upload này?')) {
      try {
        await this.props.deleteTKT1FileUpload(fileUpload._id);
        
        // Refresh data
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1FileUploads(apiQuery, window.location.href);
        
        toast.success('Xóa file upload thành công!');
      } catch (error) {
        console.error('Error deleting file upload:', error);
        toast.error('Lỗi khi xóa file upload. Vui lòng thử lại.');
      }
    }
  }


  // Upload functionality
  handleOpenUploadModal = () => {
    // Set upload type based on album type or route type
    const shouldBePublic = this.shouldUploadBePublic();
    const routeType = this.getRouteType();
    
    // Override localStorage for ornament routes to ensure public upload
    const ornamentRoutes = ['ONM_SHAPE', 'ONM_OBJECT', 'ONM_IMAGE'];
    if (ornamentRoutes.includes(routeType)) {
      // Force override localStorage for ornament routes
      localStorage.setItem('tkt1_upload_is_public', JSON.stringify(true));
    }
    
    this.setState({ 
      showUploadModal: true,
      uploadIsPublic: shouldBePublic // This will be true for ornament routes
    });
  }

  handleCloseUploadModal = () => {
    this.setState({ 
      showUploadModal: false,
      selectedFiles: [],
      filePreviews: [],
      uploadNote: '',
      createThumbnail: true,
      customFilenames: {},
      uploadProgress: {
        current: 0,
        total: 0,
        currentFileName: '',
        isUploading: false
      }
      // Note: uploadIsPublic is not reset to preserve user's choice
    });
  }

  handleUploadTypeChange = (isPublic) => {
    this.setState({ uploadIsPublic: isPublic });
    localStorage.setItem('tkt1_upload_is_public', JSON.stringify(isPublic));
  }

  handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    const previews = [];
    
    files.forEach((file, index) => {
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (event) => {
          previews[index] = {
            url: event.target.result,
            name: file.name,
            size: file.size,
            type: file.type
          };
          this.setState({ filePreviews: [...previews] });
        };
        reader.readAsDataURL(file);
      } else {
        previews[index] = {
          url: null,
          name: file.name,
          size: file.size,
          type: file.type
        };
      }
    });
    
    this.setState({ 
      selectedFiles: files,
      filePreviews: previews
    });
  }

  handleUploadNoteChange = (e) => {
    this.setState({ uploadNote: e.target.value });
  }

  handleThumbnailToggle = (e) => {
    this.setState({ createThumbnail: e.target.checked });
  }

  handleFilenameChange = (fileIndex, filename) => {
    this.setState(prevState => ({
      customFilenames: {
        ...prevState.customFilenames,
        [fileIndex]: filename
      }
    }));
  }

  // Media modal handlers (for both images and videos)
  handleImageClick = (fileUpload) => {
    // Support both images and videos
    if (this.isMediaFile(fileUpload.type, fileUpload.mime_type)) {
      const mediaFiles = this.getMediaFiles();
      const mediaUrl = this.getFileUrl(fileUpload.s3_key, fileUpload.is_public);
      const displayName = fileUpload.filename || fileUpload.original_filename;
      
      // Find index of current media in the media files list
      const mediaIndex = mediaFiles.findIndex(file => file._id === fileUpload._id);
      
      this.setState({
        showImageModal: true,
        selectedFileUpload: fileUpload,
        selectedImageUrl: mediaUrl,
        selectedImageName: displayName,
        selectedImageIndex: mediaIndex >= 0 ? mediaIndex : 0
      });
    }
  }

  handleCloseImageModal = () => {
    this.setState({
      showImageModal: false,
      selectedFileUpload: null,
      selectedImageUrl: '',
      selectedImageName: '',
      selectedImageIndex: 0
    });
  }

  handleFastModeToggle = () => {
    this.setState(prevState => {
      const newFastMode = !prevState.fastMode;
      // Save to localStorage
      localStorage.setItem('tkt1_file_upload_fast_mode', JSON.stringify(newFastMode));
      return { fastMode: newFastMode };
    });
  }

  getDisplayImageUrl = () => {
    if (!this.state.selectedFileUpload) return this.state.selectedImageUrl;
    
    console.log('Fast Mode Debug:', {
      fastMode: this.state.fastMode,
      hasResized: !!this.state.selectedFileUpload.resized_s3_key,
      resizedKey: this.state.selectedFileUpload.resized_s3_key,
      selectedFileUpload: this.state.selectedFileUpload
    });
    
    // If Fast Mode is enabled, use resized image if available
    if (this.state.fastMode && this.state.selectedFileUpload.resized_s3_key) {
      const resizedUrl = this.getResizedUrl(this.state.selectedFileUpload.resized_s3_key, this.state.selectedFileUpload.is_public);
      console.log('Using resized URL:', resizedUrl);
      return resizedUrl;
    }
    
    // Otherwise use original image
    console.log('Using original image URL:', this.state.selectedImageUrl);
    return this.state.selectedImageUrl;
  }

  // Get all image files from the current list
  getImageFiles = () => {
    const { fileUploads } = this.props;
    return fileUploads.filter(file => this.isImageFile(file.type, file.mime_type));
  }

  // Get all media files (images, videos, and SVG) from the current list
  getMediaFiles = () => {
    const { fileUploads } = this.props;
    return fileUploads.filter(file => 
      this.isMediaFile(file.type, file.mime_type) || 
      this.isSvgFile(file.type, file.mime_type, file.original_filename)
    );
  }

  // Navigation handlers for media modal (images and videos)
  handlePrevImage = () => {
    const mediaFiles = this.getMediaFiles();
    const { selectedImageIndex } = this.state;
    
    if (selectedImageIndex > 0) {
      const prevIndex = selectedImageIndex - 1;
      const prevFile = mediaFiles[prevIndex];
      
      if (prevFile) {
        const mediaUrl = this.getFileUrl(prevFile.s3_key, prevFile.is_public);
        const displayName = prevFile.filename || prevFile.original_filename;
        
        this.setState({
          selectedFileUpload: prevFile,
          selectedImageUrl: mediaUrl,
          selectedImageName: displayName,
          selectedImageIndex: prevIndex
        });
      }
    }
  }

  handleNextImage = () => {
    const mediaFiles = this.getMediaFiles();
    const { selectedImageIndex } = this.state;
    
    if (selectedImageIndex < mediaFiles.length - 1) {
      const nextIndex = selectedImageIndex + 1;
      const nextFile = mediaFiles[nextIndex];
      
      if (nextFile) {
        const mediaUrl = this.getFileUrl(nextFile.s3_key, nextFile.is_public);
        const displayName = nextFile.filename || nextFile.original_filename;
        
        this.setState({
          selectedFileUpload: nextFile,
          selectedImageUrl: mediaUrl,
          selectedImageName: displayName,
          selectedImageIndex: nextIndex
        });
      }
    }
  }

  // Keyboard navigation handler
  handleKeyDown = (event) => {
    // Only handle keyboard navigation when media modal is open
    if (!this.state.showImageModal) return;
    
    // Prevent default behavior for arrow keys
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
    }
    
    switch (event.key) {
      case 'ArrowLeft':
        this.handlePrevImage();
        break;
      case 'ArrowRight':
        this.handleNextImage();
        break;
      case 'Escape':
        this.handleCloseImageModal();
        break;
      default:
        break;
    }
  }

  getFileIconClass = (mimeType) => {
    if (mimeType.startsWith('image/')) return 'text-primary';
    if (mimeType.startsWith('video/')) return 'text-danger';
    if (mimeType === 'application/pdf') return 'text-danger';
    if (mimeType.includes('word') || mimeType.includes('document')) return 'text-primary';
    if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return 'text-success';
    if (mimeType.includes('powerpoint') || mimeType.includes('presentation')) return 'text-warning';
    if (mimeType.includes('zip') || mimeType.includes('rar')) return 'text-secondary';
    return 'text-muted';
  }

  handleUploadFiles = async () => {
    if (!this.state.selectedFiles || this.state.selectedFiles.length === 0) {
      toast.error('Vui lòng chọn files để upload!');
      return;
    }

    // Determine upload type - override for ornament routes
    const routeType = this.getRouteType();
    const ornamentRoutes = ['ONM_SHAPE', 'ONM_OBJECT', 'ONM_IMAGE'];
    // Force public for ornament routes, otherwise use state or shouldUploadBePublic()
    const finalUploadIsPublic = ornamentRoutes.includes(routeType) 
      ? true 
      : (this.shouldUploadBePublic() || this.state.uploadIsPublic);

    // Debug info
    const token = getToken(); // Use proper token getter
    console.log('=== UPLOAD DEBUG INFO ===');
    console.log('Selected files:', this.state.selectedFiles.length);
    console.log('Route type:', routeType);
    console.log('Is ornament route:', ornamentRoutes.includes(routeType));
    console.log('Upload type:', finalUploadIsPublic ? 'Public' : 'Private');
    console.log('State uploadIsPublic:', this.state.uploadIsPublic);
    console.log('shouldUploadBePublic():', this.shouldUploadBePublic());
    console.log('Token exists:', !!token);
    console.log('Token length:', token ? token.length : 0);
    console.log('Token preview:', token ? token.substring(0, 50) + '...' : 'No token');
    console.log('API URL:', getApiUrl());
    console.log('========================');

    // Initialize upload progress
    this.setState({ 
      uploadingFiles: true,
      uploadProgress: {
        current: 0,
        total: this.state.selectedFiles.length,
        currentFileName: '',
        isUploading: true
      }
    });

    try {
      for (let i = 0; i < this.state.selectedFiles.length; i++) {
        const file = this.state.selectedFiles[i];
        
        // Update progress for current file
        this.setState({
          uploadProgress: {
            current: i + 1,
            total: this.state.selectedFiles.length,
            currentFileName: file.name,
            isUploading: true
          }
        });
        const formData = new FormData();
        formData.append('media', file); // Backend expects 'media' field name
        formData.append('create_thumbnail', this.state.createThumbnail); // Add thumbnail parameter

        // Auto-add metadata for album route
        const albumMid = this.getAlbumMid();
        console.log('Upload debug - routeType:', routeType, 'albumMid:', albumMid);
        
        if (routeType === 'ALBUM' && albumMid) {
          // Set metadata for upload API
          const metadata = {
            belong_to_albums: albumMid
          };
          formData.append('metadata', JSON.stringify(metadata));
          console.log('Upload debug - Added metadata to formData:', metadata);
        }

        // Choose endpoint based on final upload type (force public for ornament routes)
        const endpoint = finalUploadIsPublic ? '/api/upload/media-public' : '/api/upload/media';
        
        // Use proper token getter
        const token = getToken();
        
        if (!token) {
          throw new Error('No authentication token found. Please login again.');
        }
        
        console.log(`Uploading file ${i + 1}/${this.state.selectedFiles.length}:`, file.name, 'to endpoint:', endpoint);
        console.log('Create thumbnail:', this.state.createThumbnail);
        console.log('Using token:', token.substring(0, 20) + '...');
        
        const response = await fetch(`${getApiUrl()}${endpoint}`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`
          },
          body: formData
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error('Upload error response:', errorText);
          throw new Error(`Upload failed for ${file.name}: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        
        if (result.success && result.data) {
          // Get custom filename or use original
          const customFilename = this.state.customFilenames[this.state.selectedFiles.indexOf(file)];
          const finalFilename = customFilename && customFilename.trim() ? customFilename.trim() : file.name;
          
          // Create file record data
          const fileData = {
            type: this.getFileTypeFromUrl(result.data.url),
            username: localStorage.getItem('tkt1_username') || 'unknown',
            original_filename: file.name,
            filename: finalFilename,
            s3_key: result.data.url,
            file_size: file.size,
            mime_type: file.type,
            bucket_name: finalUploadIsPublic ? 'public' : 'private',
            is_public: finalUploadIsPublic,
            status: 'UPLOADED',
            upload_method: 'DIRECT',
            note: this.state.uploadNote,
            // Use metadata from upload response if available
            metadata: result.data.metadata || null
          };

          // Debug metadata from upload response
          console.log('Upload debug - Metadata from upload response:', result.data.metadata);
          console.log('Upload debug - Final fileData.metadata:', fileData.metadata);
          
          // Create file record in database
          await this.props.createTKT1FileUpload(fileData);
          console.log('File uploaded and record created successfully:', fileData);
        }
      }
      
      // Clear selected files and close modal
      this.setState({ 
        selectedFiles: [],
        filePreviews: [],
        showUploadModal: false,
        uploadNote: '',
        createThumbnail: true,
        customFilenames: {},
        uploadProgress: {
          current: 0,
          total: 0,
          currentFileName: '',
          isUploading: false
        }
        // Note: uploadIsPublic is not reset to preserve user's choice
      });
      
      // Refresh the file list
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1FileUploads(apiQuery, window.location.href);
      
      // Show success message with album info if applicable
      const albumMid = this.getAlbumMid();
      let successMessage = `Upload ${this.state.selectedFiles.length} files thành công! (${finalUploadIsPublic ? 'Public' : 'Private'})`;
      
      if (routeType === 'ALBUM' && albumMid) {
        successMessage += ` - Đã tự động thêm vào album ${albumMid}`;
      }
      
      if (ornamentRoutes.includes(routeType)) {
        successMessage += ` - Ornament route (forced Public)`;
      }
      
      toast.success(successMessage);
    } catch (error) {
      console.error('Error uploading files:', error);
      console.error('Error details:', {
        message: error.message,
        stack: error.stack,
        name: error.name
      });
      
      // Show more detailed error message
      let errorMessage = 'Lỗi khi upload files. Vui lòng thử lại.';
      if (error.message.includes('No authentication token')) {
        errorMessage = 'Không tìm thấy token xác thực. Vui lòng đăng nhập lại.';
      } else if (error.message.includes('401')) {
        errorMessage = 'Token đã hết hạn. Vui lòng đăng nhập lại.';
      } else if (error.message.includes('403')) {
        errorMessage = 'Không có quyền upload. Vui lòng kiểm tra quyền truy cập.';
      } else if (error.message.includes('413')) {
        errorMessage = 'File quá lớn. Vui lòng chọn file nhỏ hơn.';
      } else if (error.message.includes('500')) {
        errorMessage = 'Lỗi server. Vui lòng thử lại sau.';
      }
      
      toast.error(`${errorMessage} - Chi tiết: ${error.message}`);
    } finally {
      this.setState({ 
        uploadingFiles: false,
        uploadProgress: {
          current: 0,
          total: 0,
          currentFileName: '',
          isUploading: false
        }
      });
    }
  }

  handleFilesUploaded = async (newFiles) => {
    this.setState({ uploadingFiles: true });
    
    try {
      // Process each uploaded file
      for (const file of newFiles) {
        const fileData = {
          type: this.getFileTypeFromUrl(file.link),
          username: localStorage.getItem('username') || 'unknown',
          original_filename: file.originalName || file.link.split('/').pop(),
          s3_key: file.link,
          file_size: file.size || 0,
          mime_type: file.mimeType || 'application/octet-stream',
          bucket_name: this.state.uploadIsPublic ? 'public' : 'private',
          is_public: this.state.uploadIsPublic,
          status: 'UPLOADED',
          upload_method: 'DIRECT',
          note: file.description || ''
        };
        
        // Here you would typically call an API to save the file record
        // For now, we'll just refresh the data
        console.log('File uploaded:', fileData);
      }
      
      // Refresh the file list
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1FileUploads(apiQuery, window.location.href);
      
      alert(`Upload files thành công! (${this.state.uploadIsPublic ? 'Public' : 'Private'})`);
    } catch (error) {
      console.error('Error processing uploaded files:', error);
      alert('Lỗi khi xử lý files đã upload. Vui lòng thử lại.');
    } finally {
      this.setState({ uploadingFiles: false });
    }
  }

  getFileTypeFromUrl = (url) => {
    const extension = url.split('.').pop().toLowerCase();
    const typeMap = {
      // Images
      'jpg': 'IMAGE', 'jpeg': 'IMAGE', 'png': 'IMAGE', 'gif': 'IMAGE', 
      'bmp': 'IMAGE', 'webp': 'IMAGE', 'svg': 'IMAGE', 'ico': 'IMAGE',
      // Videos
      'mp4': 'VIDEO', 'avi': 'VIDEO', 'mov': 'VIDEO', 'wmv': 'VIDEO', 
      'flv': 'VIDEO', 'webm': 'VIDEO', 'mkv': 'VIDEO',
      // Documents
      'pdf': 'PDF', 'doc': 'DOC', 'docx': 'DOCX', 'txt': 'TXT', 
      'json': 'JSON', 'csv': 'CSV',
      // Spreadsheets
      'xls': 'XLS', 'xlsx': 'XLSX',
      // Presentations
      'ppt': 'PPT', 'pptx': 'PPTX',
      // Archives
      'zip': 'ZIP', 'rar': 'RAR'
    };
    return typeMap[extension] || 'OTHER';
  }

  // Generate full S3 URL
  getFileUrl = (s3Key, isPublic = false) => {
    if (!s3Key) return '';
    const bucketName = isPublic ? 'tkt1-public-images' : 'tkt1-images';
    const baseUrl = `https://${bucketName}.s3.ap-southeast-2.amazonaws.com`;
    return `${baseUrl}/${s3Key}`;
  }

  // Generate thumbnail URL
  getThumbnailUrl = (thumbnailS3Key, isPublic = false) => {
    if (!thumbnailS3Key) return '';
    const bucketName = isPublic ? 'tkt1-public-images' : 'tkt1-images';
    const baseUrl = `https://${bucketName}.s3.ap-southeast-2.amazonaws.com`;
    return `${baseUrl}/${thumbnailS3Key}`;
  }

  // Generate resized URL
  getResizedUrl = (resizedS3Key, isPublic = false) => {
    if (!resizedS3Key) return '';
    const bucketName = isPublic ? 'tkt1-public-images' : 'tkt1-images';
    const baseUrl = `https://${bucketName}.s3.ap-southeast-2.amazonaws.com`;
    return `${baseUrl}/${resizedS3Key}`;
  }

  // Check if file is an image
  isImageFile = (type, mimeType) => {
    return type === 'IMAGE' || (mimeType && mimeType.startsWith('image/'));
  }

  // Check if file is a video
  isVideoFile = (type, mimeType) => {
    return type === 'VIDEO' || (mimeType && mimeType.startsWith('video/'));
  }

  // Check if file is media (image or video)
  isMediaFile = (type, mimeType) => {
    return this.isImageFile(type, mimeType) || this.isVideoFile(type, mimeType);
  }

  // Check if file is SVG (should display directly, not thumbnail)
  isSvgFile = (type, mimeType, originalFilename) => {
    if (mimeType === 'image/svg+xml') return true;
    if (originalFilename && originalFilename.toLowerCase().endsWith('.svg')) return true;
    return false;
  }

  // Helper function to prepare API query
  prepareApiQuery = (query) => {
    const { showColumns, search, type, status, username, belong_to_albums, show_sidebar, ...baseQuery } = query;
    const apiQuery = {
      ...baseQuery,
      search: search ? search.trim() : ''
    };
    
    // Add type filter if selected
    if (type && type.trim()) {
      apiQuery.type = type;
    }
    
    // Add status filter if selected
    if (status && status.trim()) {
      apiQuery.status = status;
    }
    
    // Add username filter if selected
    if (username && username.trim()) {
      apiQuery.username = username;
    }
    
    // Add album filter if selected
    if (belong_to_albums && belong_to_albums.trim()) {
      apiQuery.belong_to_albums = belong_to_albums;
    }
    
    return apiQuery;
  }

  handleChangeItemsPerPage = (e) => {
    const itemsPerPage = parseInt(e.target.value);
    const trimmedQuery = {
      ...this.state.query,
      itemsPerPage,
      currentPage: 1,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    // Save to localStorage based on route type
    const routeType = this.getRouteType();
    const queryKey = `tkt1_file_upload_management_query_${routeType}`;
    localStorage.setItem(queryKey, JSON.stringify(trimmedQuery));
    
    this.setState({
      query: { ...this.state.query, itemsPerPage, currentPage: 1 }
    }, () => {
      this.updateUrl(trimmedQuery);
      this.props.getTKT1FileUploads(apiQuery, window.location.href);
    })
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleSearch();
  }

  handleSearch = () => {
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.updateUrl(trimmedQuery);
    this.props.getTKT1FileUploads(apiQuery, window.location.href);
    
    // Save to localStorage based on route type
    const routeType = this.getRouteType();
    const queryKey = `tkt1_file_upload_management_query_${routeType}`;
    localStorage.setItem(queryKey, JSON.stringify(trimmedQuery));
  }

  updateUrl = (query) => {
    const { history } = this.props;
    // Remove showColumns from URL query - it's only for client display
    const { showColumns, ...urlQuery } = query;
    const queryStr = queryString.stringify(urlQuery);

    // Determine pathname based on route type
    const routeType = this.getRouteType();
    const albumMid = this.getAlbumMid();
    
    let pathname;
    if (routeType === 'ALBUM' && albumMid) {
      // Keep album route
      pathname = `/admin/tkt1-media/album-detail/${albumMid}`;
    } else {
      // Regular upload management routes
    const pathMap = {
      'all': '/admin/tkt1-media/upload-management/all',
      'IMAGE': '/admin/tkt1-media/upload-management/image',
      'VIDEO': '/admin/tkt1-media/upload-management/video',
      'PDF': '/admin/tkt1-media/upload-management/pdf',
      'DOC': '/admin/tkt1-media/upload-management/doc',
      'OTHER': '/admin/tkt1-media/upload-management/other'
    };
      pathname = pathMap[routeType] || '/admin/tkt1-media/upload-management/all';
    }

    history.push({
      pathname: pathname,
      search: queryStr,
    });
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.query.currentPage)
      return;

    const trimmedQuery = {
      ...this.state.query,
      currentPage: newPage,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);

    this.setState({
      query: { ...this.state.query, currentPage: newPage },
    }, () => {
      this.setState({ fileUploads: [] }, () => {
        this.updateUrl(trimmedQuery);
        this.props.getTKT1FileUploads(apiQuery, window.location.href);
        
        // Save to localStorage based on route type
        const routeType = this.getRouteType();
        const queryKey = `tkt1_file_upload_management_query_${routeType}`;
        localStorage.setItem(queryKey, JSON.stringify(trimmedQuery));
      })
    })
  }

  renderSearchFilter = () => {
    return <>
      <Row className="mb-3">
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        {this.shouldShowTypeFilter() && (
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Loại</InputGroup.Text>
            <Form.Select
              value={this.state.query.type}
              onChange={this.handleTypeChange}
            >
              <option value="">Tất cả</option>
              <option value="IMAGE">Hình ảnh</option>
              <option value="VIDEO">Video</option>
              <option value="PDF">PDF</option>
              <option value="DOC">Tài liệu</option>
              <option value="OTHER">Khác</option>
            </Form.Select>
          </InputGroup>
        </Col>
        )}
        <Col md={this.shouldShowTypeFilter() ? "2" : "2"}>
          <InputGroup>
            <InputGroup.Text>Trạng thái</InputGroup.Text>
            <Form.Select
              value={this.state.query.status}
              onChange={this.handleStatusChange}
            >
              <option value="">Tất cả</option>
              <option value="UPLOADING">Đang tải lên</option>
              <option value="UPLOADED">Đã tải lên</option>
              <option value="PROCESSING">Đang xử lý</option>
              <option value="PROCESSED">Đã xử lý</option>
              <option value="FAILED">Thất bại</option>
              <option value="DELETED">Đã xóa</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md={this.shouldShowTypeFilter() ? "2" : "3"}>
          <InputGroup>
            <InputGroup.Text>Username</InputGroup.Text>
            <Form.Control
              type="text"
              value={this.state.query.username}
              onChange={this.handleUsernameChange}
              placeholder="Username"
            />
          </InputGroup>
        </Col>
        <Col md={this.shouldShowTypeFilter() ? "2" : "3"}>
          <InputGroup>
            <InputGroup.Text>Sắp xếp</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={this.handleSelectSort}
            >
              <option value="upload_date">Ngày tải lên</option>
              <option value="original_filename">Tên file</option>
              <option value="file_size">Kích thước</option>
              <option value="type">Loại</option>
              <option value="username">Username</option>
              <option value="created_at">Ngày tạo</option>
              <option value="updated_at">Ngày cập nhật</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md={this.shouldShowTypeFilter() ? "1" : "1"} className="d-flex align-items-center" style={{marginBottom: '16px'}}>
          <div className="btn-group" role="group">
            <Button
              variant={this.state.query.sortOrder === -1 ? 'primary' : 'outline-secondary'}
              size="sm"
              onClick={() => this.handleSelectSortOrder({ target: { value: '-1' } })}
              title="Giảm dần"
            >
              <FaSortAmountDown />
            </Button>
            <Button
              variant={this.state.query.sortOrder === 1 ? 'primary' : 'outline-secondary'}
              size="sm"
              onClick={() => this.handleSelectSortOrder({ target: { value: '1' } })}
              title="Tăng dần"
            >
              <FaSortAmountUp />
            </Button>
          </div>
        </Col>
        <Col md="1" className="d-flex align-items-center">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
            size=""
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
      
      {/* Multiple Mode Toggle */}
      <Row className="mb-3">
        <Col md="12">
          <div className="d-flex align-items-center gap-3">
            <Form.Check
              type="checkbox"
              id="multipleMode"
              label="Chế độ chọn nhiều"
              checked={this.state.multipleMode}
              onChange={this.handleMultipleModeToggle}
            />
            <Form.Check
              type="checkbox"
              id="fastMode"
              label="Fast Mode"
              checked={this.state.fastMode}
              onChange={this.handleFastModeToggle}
            />
            {this.state.multipleMode && (
              <div className="d-flex align-items-center gap-3">
                <span className="text-muted">
                  Đã chọn: <strong className="text-primary">{this.state.selectedFileIds.length}</strong> file
                </span>
                {this.state.selectedFileIds.length > 0 && (
                  <span className="text-success small">
                    <i className="fas fa-check-circle me-1"></i>
                    Sẵn sàng thực hiện thao tác
                  </span>
                )}
              </div>
            )}
          </div>
        </Col>
      </Row>

      {/* Multiple Selection Controls - Only show when multiple mode is enabled */}
      {this.state.multipleMode && (
        <Row className="mb-3">
          <Col md="6">
            <div className="d-flex gap-2 align-items-center">
              <Button
                variant="outline-primary"
                size="sm"
                onClick={this.handleSelectAll}
                disabled={this.state.selectAll}
              >
                <i className="fas fa-check-double me-1"></i>
                Chọn tất cả
              </Button>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={this.handleDeselectAll}
                disabled={this.state.selectedFileIds.length === 0}
              >
                <i className="fas fa-times me-1"></i>
                Bỏ chọn tất cả
              </Button>
            </div>
            <div className="small text-muted mt-1">
              <i className="fas fa-info-circle me-1"></i>
              Click vào checkbox của từng file để chọn thủ công
            </div>
          </Col>
          <Col md="6" className="text-end">
            {this.state.selectedFileIds.length > 0 && (
              <div className="d-flex align-items-center gap-2">
                <span className="text-muted small">
                  {this.state.selectedFileIds.length} file đã chọn
                </span>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={this.handleAddToAlbum}
                  className="me-2"
                >
                  <i className="fas fa-images me-1"></i>
                  Thêm vào Album
                </Button>
                <Dropdown>
                  <Dropdown.Toggle variant="success" size="sm">
                    <i className="fas fa-tasks me-1"></i>
                    Thao tác nhiều
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={this.handleAddToAlbum}>
                      <i className="fas fa-images me-2"></i>
                      Thêm vào Album
                    </Dropdown.Item>
                    {this.getRouteType() === 'ALBUM' && (
                      <Dropdown.Item onClick={this.handleRemoveFromCurrentAlbum}>
                        <i className="fas fa-minus me-2"></i>
                        Xóa khỏi album hiện tại
                      </Dropdown.Item>
                    )}
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={this.handleDeleteSelectedFiles} className="text-danger">
                      <i className="fas fa-trash me-2"></i>
                      Xóa ảnh
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}
          </Col>
        </Row>
      )}
    </>
  }

  renderFileUploadGrid = () => {
    const { fileUploads, currentUrl } = this.props;
    const { showColumns, viewMode, gridSize } = this.state;
    const currentShowColumns = showColumns[viewMode] || showColumns.grid;
    
    // Check if current URL matches the URL in reducer to prevent showing stale data
    const currentWindowUrl = window.location.href;
    if (currentUrl && currentUrl !== currentWindowUrl) {
      return <LoadingSpinner text="Đang tải dữ liệu..." size="lg" />;
    }
    
    // Calculate column classes based on grid size
    const getColumnClass = () => {
      if (gridSize === 6) {
        return 'col-lg-2 col-md-3 col-sm-6 mb-4'; // 6 items per row
      } else {
        return 'col-lg-3 col-md-4 col-sm-6 mb-4'; // 4 items per row (default)
      }
    };
    
    // Ensure fileUploads is an array and filter out any null/undefined items
    const safeFileUploads = Array.isArray(fileUploads) ? fileUploads.filter(fileUpload => fileUpload != null && typeof fileUpload === 'object') : [];
    
    // Early return if no data
    if (!safeFileUploads || safeFileUploads.length === 0) {
      return (
        <div className="text-center py-5">
          <i className="fas fa-folder-open fa-3x text-muted mb-3"></i>
          <h5 className="text-muted">
            {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
          </h5>
        </div>
      );
    }

    return (
      <div className="row">
        {safeFileUploads.map((fileUpload, index) => {
          if (!fileUpload || typeof fileUpload !== 'object') return null;
          
          return (
            <div key={fileUpload._id || index} className={getColumnClass()}>
              <Card className="h-100 shadow-sm">
                {/* Checkbox - Only show when multiple mode is enabled */}
                {this.state.multipleMode && (
                  <div className="position-absolute top-0 start-0 m-2" style={{ zIndex: 10 }}>
                    <Form.Check
                      type="checkbox"
                      checked={this.state.selectedFileIds.includes(fileUpload._id)}
                      onChange={() => this.handleFileSelectForMultiple(fileUpload._id)}
                      className="bg-white rounded"
                    />
                  </div>
                )}
                {/* Thumbnail/Preview */}
                {currentShowColumns.thumbnail_url && (
                  <div className="position-relative" style={{ height: '200px', overflow: 'hidden' }}>
                    {/* For SVG files, always show original file directly */}
                    {this.isSvgFile(fileUpload.type, fileUpload.mime_type, fileUpload.original_filename) ? (
                      <img 
                        src={this.getFileUrl(fileUpload.s3_key, fileUpload.is_public)} 
                        alt={fileUpload.original_filename}
                        className="card-img-top"
                        style={{ 
                          height: '100%', 
                          objectFit: 'contain',
                          cursor: 'pointer'
                        }}
                        onClick={() => this.handleImageClick(fileUpload)}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                    ) : fileUpload.thumbnail_s3_key ? (
                      <img 
                        src={this.getThumbnailUrl(fileUpload.thumbnail_s3_key, fileUpload.is_public)} 
                        alt={`Thumbnail of ${fileUpload.original_filename}`}
                        className="card-img-top"
                        style={{ 
                          height: '100%', 
                          objectFit: 'cover',
                          cursor: 'pointer'
                        }}
                        onClick={() => this.handleImageClick(fileUpload)}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                    ) : this.isMediaFile(fileUpload.type, fileUpload.mime_type) ? (
                      this.isVideoFile(fileUpload.type, fileUpload.mime_type) ? (
                        <div 
                          className="position-relative h-100"
                          style={{ cursor: 'pointer' }}
                          onClick={() => this.handleImageClick(fileUpload)}
                        >
                          {/* For SVG files, always show original file directly */}
                          {this.isSvgFile(fileUpload.type, fileUpload.mime_type, fileUpload.original_filename) ? (
                            <img 
                              src={this.getFileUrl(fileUpload.s3_key, fileUpload.is_public)} 
                              alt={fileUpload.original_filename}
                              className="card-img-top"
                              style={{ 
                                height: '100%', 
                                objectFit: 'contain'
                              }}
                            />
                          ) : fileUpload.thumbnail_s3_key ? (
                            <img 
                              src={this.getThumbnailUrl(fileUpload.thumbnail_s3_key, fileUpload.is_public)} 
                              alt={`Thumbnail of ${fileUpload.original_filename}`}
                              className="card-img-top"
                              style={{ 
                                height: '100%', 
                                objectFit: 'cover'
                              }}
                            />
                          ) : (
                            <div 
                              className="d-flex align-items-center justify-content-center h-100"
                              style={{ backgroundColor: '#000' }}
                            >
                              <i className="fas fa-play-circle fa-3x text-white"></i>
                            </div>
                          )}
                          <div className="position-absolute bottom-0 start-0 m-2">
                            <Badge bg="danger" style={{ fontSize: '0.7em' }}>
                              <i className="fas fa-video me-1"></i>
                              Video
                            </Badge>
                          </div>
                        </div>
                      ) : (
                        <img 
                          src={this.getFileUrl(fileUpload.s3_key, fileUpload.is_public)} 
                          alt={fileUpload.original_filename}
                          className="card-img-top"
                          style={{ 
                            height: '100%', 
                            objectFit: 'cover',
                            cursor: 'pointer'
                          }}
                          onClick={() => this.handleImageClick(fileUpload)}
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                          }}
                        />
                      )
                    ) : (
                      <div 
                        className="d-flex align-items-center justify-content-center h-100"
                        style={{ backgroundColor: '#f8f9fa' }}
                      >
                        <div className="text-center">
                          {this.getFileIcon(fileUpload.type)}
                          <div className="mt-2 small text-muted">No Preview</div>
                        </div>
                      </div>
                    )}
                  
                    {/* Error fallback */}
                    <div 
                      className="d-none align-items-center justify-content-center h-100"
                      style={{ backgroundColor: '#f8f9fa' }}
                    >
                      <div className="text-center">
                        <i className="fas fa-image fa-2x text-muted mb-2"></i>
                        <div className="small text-muted">Lỗi hiển thị</div>
                      </div>
                    </div>
                    
                    {/* Status badge */}
                    {currentShowColumns.status && (
                      <div className="position-absolute top-0 end-0 m-2">
                        <Badge 
                          bg={
                            fileUpload.status === 'UPLOADED' ? 'success' :
                            fileUpload.status === 'UPLOADING' ? 'warning' :
                            fileUpload.status === 'PROCESSING' ? 'info' :
                            fileUpload.status === 'PROCESSED' ? 'primary' :
                            fileUpload.status === 'FAILED' ? 'danger' :
                            fileUpload.status === 'DELETED' ? 'dark' :
                            'secondary'
                          }
                          style={{ fontSize: '0.7em' }}
                        >
                          {this.mapStatus(fileUpload.status)}
                        </Badge>
                      </div>
                    )}
                    
                    {/* Public/Private badge */}
                    {currentShowColumns.is_public && (
                      <div className="position-absolute top-0 start-0 m-2">
                        <Badge 
                          bg={fileUpload.is_public ? 'success' : 'secondary'}
                          style={{ fontSize: '0.7em' }}
                        >
                          {fileUpload.is_public ? 'Public' : 'Private'}
                        </Badge>
                      </div>
                    )}
                    
                    {/* Private file lock icon */}
                    {!fileUpload.is_public && (
                      <div className="position-absolute bottom-0 end-0 m-2">
                        <div 
                          style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.7)',
                            borderRadius: '50%',
                            padding: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                          title="File riêng tư"
                        >
                          <FaLock size={12} color="white" />
                        </div>
                      </div>
                    )}
                  </div>
                )}
                
                <Card.Body className="d-flex flex-column">
                  {/* File name */}
                  <Card.Title className="h6 mb-2" style={{ fontSize: '0.9em' }}>
                    <div className="d-flex align-items-center">
                      {this.getFileIcon(fileUpload.type)}
                      <span 
                        className="ms-2 text-truncate" 
                        title={fileUpload.filename || fileUpload.original_filename}
                      >
                        {currentShowColumns.filename && fileUpload.filename ? fileUpload.filename : 
                         currentShowColumns.original_filename ? fileUpload.original_filename : 
                         fileUpload.filename || fileUpload.original_filename}
                      </span>
                    </div>
                  </Card.Title>
                  
                  {/* File info */}
                  <div className="mb-2">
                    {currentShowColumns._id && (
                      <div className="small text-muted d-flex align-items-center gap-2">
                        <strong>ID:</strong> 
                        <span style={{ fontFamily: 'monospace', fontSize: '0.85em' }} title={fileUpload._id}>
                          {fileUpload._id ? fileUpload._id.substring(0, 8) + '...' : '-'}
                        </span>
                        {fileUpload._id && (
                          <FaCopy 
                            size={10} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(fileUpload._id)}
                            title="Copy ID"
                          />
                        )}
                      </div>
                    )}
                    {currentShowColumns.type && (
                      <div className="small text-muted">
                        <strong>Loại:</strong> {this.mapType(fileUpload.type)}
                      </div>
                    )}
                    {currentShowColumns.file_size && (
                      <div className="small text-muted">
                        <strong>Kích thước:</strong> {this.formatFileSize(fileUpload.file_size)}
                      </div>
                    )}
                    {currentShowColumns.username && (
                      <div className="small text-muted">
                        <strong>Username:</strong> {fileUpload.username || '-'}
                      </div>
                    )}
                    {currentShowColumns.upload_date && (
                      <div className="small text-muted">
                        <strong>Ngày tải:</strong> {fileUpload.upload_date ? 
                          new Date(fileUpload.upload_date).toLocaleString('vi-VN', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit'
                          }) : '-'}
                      </div>
                    )}
                    {currentShowColumns.status && (
                      <div className="small text-muted">
                        <strong>Trạng thái:</strong> {this.mapStatus(fileUpload.status)}
                      </div>
                    )}
                    {currentShowColumns.is_public && (
                      <div className="small text-muted">
                        <strong>Công khai:</strong> {fileUpload.is_public ? 'Có' : 'Không'}
                      </div>
                    )}
                    {currentShowColumns.note && fileUpload.note && (
                      <div className="small text-muted">
                        <strong>Ghi chú:</strong> {fileUpload.note.length > 30 ? 
                          fileUpload.note.substring(0, 30) + '...' : fileUpload.note
                        }
                      </div>
                    )}
                  </div>
                  
                  {/* Actions */}
                  <div className="mt-auto">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="btn-group btn-group-sm" role="group">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={() => this.handleViewClick(fileUpload)}
                          title="Xem thông tin"
                        >
                          <FaEye size={12} />
                        </Button>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={() => this.handleEditClick(fileUpload)}
                          title="Chỉnh sửa"
                        >
                          <FaEdit size={12} />
                        </Button>
                        {this.getRouteType() === 'ALBUM' && (
                          <>
                            <Button
                              variant="outline-warning"
                              size="sm"
                              onClick={() => this.handleRemoveFromAlbum(fileUpload)}
                              title="Xóa khỏi album hiện tại"
                            >
                              <FaMinus size={12} />
                            </Button>
                            <Button
                              variant="outline-success"
                              size="sm"
                              onClick={() => this.handleSetAsAlbumCover(fileUpload)}
                              title="Đặt làm ảnh nền album"
                            >
                              <FaImage size={12} />
                            </Button>
                          </>
                        )}
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => this.handleDeleteClick(fileUpload)}
                          title="Xóa"
                        >
                          <FaTrash size={12} />
                        </Button>
                        {this.isSvgFile(fileUpload.type, fileUpload.mime_type, fileUpload.original_filename) && (
                          <Button
                            variant="outline-info"
                            size="sm"
                            onClick={() => window.open(`/admin/rnd/svg-detail/${fileUpload._id}`, '_blank')}
                            title="Mở SVG Detail trong tab mới"
                          >
                            <FaImage size={12} />
                          </Button>
                        )}
                      </div>
                      <Button
                        variant="outline-info"
                        size="sm"
                        onClick={() => window.open(this.getFileUrl(fileUpload.s3_key, fileUpload.is_public), '_blank')}
                        title="Mở file"
                      >
                        <FaExternalLinkAlt size={12} />
                      </Button>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          );
        })}
      </div>
    );
  }

  renderFileUploadTable = () => {
    const { fileUploads, currentUrl } = this.props;
    const { showColumns, viewMode } = this.state;
    const currentShowColumns = showColumns[viewMode] || showColumns.list;
    
    // Check if current URL matches the URL in reducer to prevent showing stale data
    const currentWindowUrl = window.location.href;
    if (currentUrl && currentUrl !== currentWindowUrl) {
      return <LoadingSpinner text="Đang tải dữ liệu..." size="lg" />;
    }
    
    // Ensure fileUploads is an array and filter out any null/undefined items
    const safeFileUploads = Array.isArray(fileUploads) ? fileUploads.filter(fileUpload => fileUpload != null && typeof fileUpload === 'object') : [];
    
    // Early return if no data to prevent any rendering issues
    if (!safeFileUploads || safeFileUploads.length === 0) {
      return (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              {this.state.multipleMode && (
                <th style={{ width: '50px' }}>
                  <Form.Check
                    type="checkbox"
                    checked={this.state.selectAll}
                    onChange={this.handleSelectAll}
                    title="Chọn tất cả"
                  />
                </th>
              )}
              <th style={{ width: '60px' }}>STT</th>
              {currentShowColumns.thumbnail_url && <th>Thumbnail</th>}
              {currentShowColumns._id && <th>ID</th>}
              {currentShowColumns.original_filename && <th>Tên file gốc</th>}
              {currentShowColumns.filename && <th>Tên file</th>}
              {currentShowColumns.type && <th>Loại</th>}
              {currentShowColumns.file_size && <th>Kích thước</th>}
              {currentShowColumns.mime_type && <th>MIME Type</th>}
              {currentShowColumns.username && <th>Username</th>}
              {currentShowColumns.upload_date && <th>Ngày tải lên</th>}
              {currentShowColumns.upload_method && <th>Phương thức</th>}
              {currentShowColumns.status && <th>Trạng thái</th>}
              {currentShowColumns.is_public && <th>Công khai</th>}
              {currentShowColumns.bucket_name && <th>Bucket</th>}
              {currentShowColumns.file_url && <th>Đường dẫn</th>}
              {currentShowColumns.ref_id && <th>Ref ID</th>}
              {currentShowColumns.ref_type && <th>Ref Type</th>}
              {currentShowColumns.metadata && <th>Metadata</th>}
              {currentShowColumns.note && <th>Ghi chú</th>}
              <th style={{ width: '120px' }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={Object.values(currentShowColumns).filter(Boolean).length + (this.state.multipleMode ? 3 : 2)} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            {this.state.multipleMode && (
              <th style={{ width: '50px' }}>
                <Form.Check
                  type="checkbox"
                  checked={this.state.selectAll}
                  onChange={this.handleSelectAll}
                  title="Chọn tất cả"
                />
              </th>
            )}
            <th style={{ width: '60px' }}>STT</th>
            {currentShowColumns.thumbnail_url && <th>Thumbnail</th>}
            {currentShowColumns._id && <th>ID</th>}
            {currentShowColumns.original_filename && <th>Tên file gốc</th>}
            {currentShowColumns.filename && <th>Tên file</th>}
            {currentShowColumns.type && <th>Loại</th>}
            {currentShowColumns.file_size && <th>Kích thước</th>}
            {currentShowColumns.mime_type && <th>MIME Type</th>}
            {currentShowColumns.username && <th>Username</th>}
            {currentShowColumns.upload_date && <th>Ngày tải lên</th>}
            {currentShowColumns.upload_method && <th>Phương thức</th>}
            {currentShowColumns.status && <th>Trạng thái</th>}
            {currentShowColumns.is_public && <th>Công khai</th>}
            {currentShowColumns.bucket_name && <th>Bucket</th>}
            {currentShowColumns.file_url && <th>Đường dẫn</th>}
            {currentShowColumns.ref_id && <th>Ref ID</th>}
            {currentShowColumns.ref_type && <th>Ref Type</th>}
            {currentShowColumns.metadata && <th>Metadata</th>}
            {currentShowColumns.note && <th>Ghi chú</th>}
            <th style={{ width: '120px' }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safeFileUploads.map((fileUpload, index) => {
            if (!fileUpload || typeof fileUpload !== 'object') return null;
              
              return (
                <tr key={fileUpload._id || index}>
                  {this.state.multipleMode && (
                    <td>
                      <Form.Check
                        type="checkbox"
                        checked={this.state.selectedFileIds.includes(fileUpload._id)}
                        onChange={() => this.handleFileSelectForMultiple(fileUpload._id)}
                      />
                    </td>
                  )}
                  <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                  {currentShowColumns._id && (
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <span style={{ fontSize: '0.9em', fontFamily: 'monospace' }} title={fileUpload._id}>
                          {fileUpload._id ? fileUpload._id.substring(0, 12) + '...' : '-'}
                        </span>
                        {fileUpload._id && (
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(fileUpload._id)}
                            title="Copy ID"
                          />
                        )}
                      </div>
                    </td>
                  )}
                  {currentShowColumns.thumbnail_url && (
                    <td>
                      {this.isMediaFile(fileUpload.type, fileUpload.mime_type) ? (
                        // For SVG files, always show original file directly
                        this.isSvgFile(fileUpload.type, fileUpload.mime_type, fileUpload.original_filename) ? (
                          <div className="d-flex flex-column align-items-center gap-2">
                            <div 
                              style={{ 
                                width: '100px', 
                                height: '100px', 
                                position: 'relative',
                                cursor: 'pointer',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                border: '2px solid #dee2e6',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                              }}
                              onClick={() => this.handleImageClick(fileUpload)}
                            >
                              <img 
                                src={this.getFileUrl(fileUpload.s3_key, fileUpload.is_public)} 
                                alt={fileUpload.original_filename}
                                style={{ 
                                  width: '100%', 
                                  height: '100%', 
                                  objectFit: 'contain'
                                }}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  e.target.nextSibling.style.display = 'flex';
                                }}
                              />
                            </div>
                          </div>
                        ) : fileUpload.thumbnail_s3_key ? (
                          <div className="d-flex flex-column align-items-center gap-2">
                            <div 
                              style={{ 
                                width: '100px', 
                                height: '100px', 
                                position: 'relative',
                                cursor: 'pointer',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                border: '2px solid #dee2e6',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                              }}
                              onClick={() => this.handleImageClick(fileUpload)}
                            >
                              <img 
                                src={this.getThumbnailUrl(fileUpload.thumbnail_s3_key, fileUpload.is_public)} 
                                alt={`Thumbnail of ${fileUpload.original_filename}`}
                                style={{ 
                                  width: '100%', 
                                  height: '100%', 
                                  objectFit: 'cover'
                                }}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  e.target.nextSibling.style.display = 'flex';
                                }}
                              />
                              {this.isVideoFile(fileUpload.type, fileUpload.mime_type) && (
                                <div className="position-absolute top-50 start-50 translate-middle">
                                  <i className="fas fa-play-circle fa-2x text-white" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}></i>
                                </div>
                              )}
                            </div>
                            <div 
                              style={{ 
                                display: 'none',
                                width: '100px',
                                height: '100px',
                                backgroundColor: '#f8f9fa',
                                border: '2px solid #dee2e6',
                                borderRadius: '8px',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '12px',
                                color: '#6c757d',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                              }}
                            >
                              <i className="fas fa-image fa-2x mb-1"></i>
                              <div>Lỗi</div>
                            </div>
                          </div>
                        ) : (
                          <div 
                            style={{ 
                              width: '100px',
                              height: '100px',
                              backgroundColor: '#f8f9fa',
                              border: '2px dashed #dee2e6',
                              borderRadius: '8px',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '12px',
                              color: '#6c757d',
                              cursor: 'pointer'
                            }}
                            onClick={() => this.handleImageClick(fileUpload)}
                          >
                            {this.isVideoFile(fileUpload.type, fileUpload.mime_type) ? (
                              <>
                                <i className="fas fa-video fa-2x mb-1 text-danger"></i>
                                <div>Video</div>
                              </>
                            ) : (
                              <>
                                <i className="fas fa-image fa-2x mb-1"></i>
                                <div>Media</div>
                              </>
                            )}
                          </div>
                        )
                      ) : (
                        <div 
                          style={{ 
                            width: '100px',
                            height: '100px',
                            backgroundColor: '#f8f9fa',
                            border: '2px dashed #dee2e6',
                            borderRadius: '8px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '12px',
                            color: '#6c757d'
                          }}
                        >
                          <i className="fas fa-image fa-2x mb-1"></i>
                          <div>Không có</div>
                        </div>
                      )}
                    </td>
                  )}
                  {currentShowColumns.original_filename && (
                    <td>
                      {fileUpload.original_filename ? (
                        <div className="d-flex align-items-center gap-2">
                          {this.getFileIcon(fileUpload.type)}
                          <span title={fileUpload.original_filename}>
                            {fileUpload.original_filename.length > 25 
                              ? fileUpload.original_filename.substring(0, 25) + '...' 
                              : fileUpload.original_filename}
                          </span>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(fileUpload.original_filename)}
                            title="Copy tên file gốc"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {currentShowColumns.filename && (
                    <td>
                      {fileUpload.filename ? (
                        <div className="d-flex align-items-center gap-2">
                          <span title={fileUpload.filename}>
                            {fileUpload.filename.length > 25 
                              ? fileUpload.filename.substring(0, 25) + '...' 
                              : fileUpload.filename}
                          </span>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(fileUpload.filename)}
                            title="Copy tên file"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {currentShowColumns.type && (
                    <td>
                      {fileUpload.type ? (
                        <Badge 
                          bg={
                            fileUpload.type === 'IMAGE' ? 'primary' :
                            fileUpload.type === 'VIDEO' ? 'danger' :
                            fileUpload.type === 'PDF' ? 'danger' :
                            fileUpload.type === 'DOC' || fileUpload.type === 'DOCX' ? 'info' :
                            fileUpload.type === 'XLS' || fileUpload.type === 'XLSX' ? 'success' :
                            fileUpload.type === 'PPT' || fileUpload.type === 'PPTX' ? 'warning' :
                            fileUpload.type === 'ZIP' || fileUpload.type === 'RAR' ? 'secondary' :
                            'dark'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapType(fileUpload.type)}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {currentShowColumns.file_size && (
                    <td>
                      {this.formatFileSize(fileUpload.file_size)}
                    </td>
                  )}
                  {currentShowColumns.mime_type && (
                    <td>
                      <span style={{ fontSize: '0.9em' }} title={fileUpload.mime_type}>
                        {fileUpload.mime_type || '-'}
                      </span>
                    </td>
                  )}
                  {currentShowColumns.username && (
                    <td>
                      {fileUpload.username ? (
                        <Badge bg="info" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                          {fileUpload.username}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {currentShowColumns.upload_date && (
                    <td>
                      {fileUpload.upload_date ? 
                        new Date(fileUpload.upload_date).toLocaleString('vi-VN', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit'
                        }) : 
                        '-'}
                    </td>
                  )}
                  {currentShowColumns.upload_method && (
                    <td>
                      {fileUpload.upload_method ? (
                        <Badge 
                          bg={
                            fileUpload.upload_method === 'DIRECT' ? 'primary' :
                            fileUpload.upload_method === 'BASE64' ? 'success' :
                            fileUpload.upload_method === 'PRESIGNED_URL' ? 'info' :
                            fileUpload.upload_method === 'MULTIPART' ? 'warning' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {fileUpload.upload_method}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {currentShowColumns.status && (
                    <td>
                      {fileUpload.status ? (
                        <Badge 
                          bg={
                            fileUpload.status === 'UPLOADED' ? 'success' :
                            fileUpload.status === 'UPLOADING' ? 'warning' :
                            fileUpload.status === 'PROCESSING' ? 'info' :
                            fileUpload.status === 'PROCESSED' ? 'primary' :
                            fileUpload.status === 'FAILED' ? 'danger' :
                            fileUpload.status === 'DELETED' ? 'dark' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(fileUpload.status)}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {currentShowColumns.is_public && (
                    <td>
                      {fileUpload.is_public ? (
                        <Badge bg="success" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                          Công khai
                        </Badge>
                      ) : (
                        <Badge bg="secondary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                          Riêng tư
                        </Badge>
                      )}
                    </td>
                  )}
                  {currentShowColumns.bucket_name && (
                    <td>
                      <span style={{ fontSize: '0.9em' }}>
                        {fileUpload.bucket_name || '-'}
                      </span>
                    </td>
                  )}
                  {currentShowColumns.file_url && (
                    <td>
                      {fileUpload.s3_key ? (
                        <div className="d-flex align-items-center gap-2">
                          <div className="flex-grow-1">
                            <div 
                              className="small text-primary" 
                              style={{ 
                                cursor: 'pointer',
                                wordBreak: 'break-all',
                                fontSize: '0.8em'
                              }}
                              title={this.getFileUrl(fileUpload.s3_key, fileUpload.is_public)}
                              onClick={() => window.open(this.getFileUrl(fileUpload.s3_key, fileUpload.is_public), '_blank')}
                            >
                              {this.getFileUrl(fileUpload.s3_key, fileUpload.is_public).length > 40 
                                ? this.getFileUrl(fileUpload.s3_key, fileUpload.is_public).substring(0, 40) + '...' 
                                : this.getFileUrl(fileUpload.s3_key, fileUpload.is_public)}
                            </div>
                            <FaCopy 
                              size={10} 
                              style={{ cursor: 'pointer', color: '#6c757d' }}
                              onClick={() => this.copyToClipboard(this.getFileUrl(fileUpload.s3_key, fileUpload.is_public))}
                              title="Copy URL"
                            />
                          </div>
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {currentShowColumns.ref_id && (
                    <td>
                      {fileUpload.ref_id ? (
                        <div className="d-flex align-items-center gap-2">
                          <span>{fileUpload.ref_id}</span>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(fileUpload.ref_id)}
                            title="Copy Ref ID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {currentShowColumns.ref_type && (
                    <td>
                      <span style={{ fontSize: '0.9em' }}>
                        {fileUpload.ref_type || '-'}
                      </span>
                    </td>
                  )}
                  {currentShowColumns.metadata && (
                    <td>
                      {fileUpload.metadata ? (
                        <div className="d-flex align-items-center gap-2">
                          <span 
                            style={{ 
                              fontSize: '0.8em',
                              cursor: 'pointer',
                              color: '#6c757d'
                            }}
                            title={JSON.stringify(fileUpload.metadata, null, 2)}
                            onClick={() => this.handleViewClick(fileUpload)}
                          >
                            {typeof fileUpload.metadata === 'object' 
                              ? Object.keys(fileUpload.metadata).length + ' fields'
                              : 'View metadata'
                            }
                          </span>
                          <FaCopy 
                            size={10} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(JSON.stringify(fileUpload.metadata, null, 2))}
                            title="Copy metadata"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {currentShowColumns.note && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} title={fileUpload.note}>
                        {fileUpload.note || '-'}
                      </div>
                    </td>
                  )}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <FaEye 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Xem thông tin"
                        onClick={() => this.handleViewClick(fileUpload)}
                      />
                      <FaEdit 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Chỉnh sửa"
                        onClick={() => this.handleEditClick(fileUpload)}
                      />
                      {this.getRouteType() === 'ALBUM' && (
                        <>
                          <FaMinus 
                            size={16} 
                            style={{ 
                              cursor: 'pointer', 
                              color: '#ffc107'
                            }}
                            title="Xóa khỏi album hiện tại"
                            onClick={() => this.handleRemoveFromAlbum(fileUpload)}
                          />
                          <FaImage 
                            size={16} 
                            style={{ 
                              cursor: 'pointer', 
                              color: '#28a745'
                            }}
                            title="Đặt làm ảnh nền album"
                            onClick={() => this.handleSetAsAlbumCover(fileUpload)}
                          />
                        </>
                      )}
                      <FaTrash 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#dc3545'
                        }}
                        title="Xóa"
                        onClick={() => this.handleDeleteClick(fileUpload)}
                      />
                      {this.isSvgFile(fileUpload.type, fileUpload.mime_type, fileUpload.original_filename) && (
                        <FaImage 
                          size={16} 
                          style={{ 
                            cursor: 'pointer', 
                            color: '#17a2b8'
                          }}
                          title="Mở SVG Detail trong tab mới"
                          onClick={() => window.open(`/admin/rnd/svg-detail/${fileUpload._id}`, '_blank')}
                        />
                      )}
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <>
        <Container 
          fluid
          onDragOver={this.handleDragOver}
          onDragLeave={this.handleDragLeave}
          onDrop={this.handleDrop}
          style={{
            position: 'relative',
            minHeight: '100vh',
            transition: 'all 0.3s ease'
          }}
        >
          <Row className="mb-4">
            <Col>
              {this.getRouteType() === 'ALBUM' && (
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <div className="d-flex align-items-center gap-3">
                    <Link 
                      to={this.getAlbumTypeLink()} 
                      className="text-decoration-none text-muted"
                      style={{ fontSize: '14px' }}
                    >
                      ← Back to {this.state.currentAlbumInfo?.type || 'Album'} Albums
                    </Link>
                    <FaExternalLinkAlt 
                      onClick={this.handleOpenFullScreen}
                      title="Mở album trong tab mới (Full screen)"
                      style={{ cursor: 'pointer', fontSize: '16px' }}
                    />
                  </div>
                  
                  <div className="d-flex align-items-center gap-3">
                    <h2 className="text-primary mb-0">
                      {(() => {
                        const routeType = this.getRouteType();
                        const albumMid = this.getAlbumMid();
                        const titleMap = {
                          'all': 'TKT1 File Upload Management - All',
                          'IMAGE': 'TKT1 File Upload Management - Image',
                          'VIDEO': 'TKT1 File Upload Management - Video',
                          'PDF': 'TKT1 File Upload Management - PDF',
                          'DOC': 'TKT1 File Upload Management - Document',
                          'OTHER': 'TKT1 File Upload Management - Other',
                          'ALBUM': this.state.currentAlbumInfo 
                            ? `Album ${this.state.currentAlbumInfo.name} (#${albumMid})`
                            : `Album #${albumMid}`
                        };
                        return titleMap[routeType] || 'TKT1 File Upload Management';
                      })()}
                    </h2>
                    <FaEdit 
                      onClick={this.handleEditCurrentAlbum}
                      title="Chỉnh sửa album"
                      style={{ cursor: 'pointer', fontSize: '16px' }}
                    />
                  </div>
                  
                  {/* Album Info Display - Aligned with Back to Listing */}
                  {console.log('TKT1FileUploadManagement - Render Debug:', {
                    routeType: this.getRouteType(),
                    loadingAlbumInfo: this.state.loadingAlbumInfo,
                    currentAlbumInfo: this.state.currentAlbumInfo,
                    showAlbumInfo: this.getRouteType() === 'ALBUM'
                  })}
                  {this.state.loadingAlbumInfo ? (
                    <div className="p-3 bg-light rounded border" style={{ minWidth: '500px' }}>
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="text-primary mb-0">
                          <i className="fas fa-info-circle me-2"></i>
                          Thông tin Album
                        </h6>
                      </div>
                      <LoadingSpinner 
                        text="Đang tải thông tin album..." 
                        variant="primary"
                        size="md"
                      />
                    </div>
                  ) : this.state.currentAlbumInfo ? (
                    <div className="p-3 bg-light rounded border" style={{ minWidth: '500px' }}>
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="text-primary mb-0">
                          <i className="fas fa-info-circle me-2"></i>
                          Thông tin Album
                        </h6>
                      </div>
                      <Row className="g-3">
                        {/* Show Original Listing and Posted Listing only for LISTING type */}
                        {this.state.currentAlbumInfo.type === 'LISTING' && (
                          <>
                            <Col md="3">
                              <div className="text-center">
                                <div className="text-muted small mb-2">
                                  <i className="fas fa-tag text-info me-1"></i>
                                  Original Listing
                                </div>
                                <div>
                                  {this.state.currentAlbumInfo.metadata?.original_listing_id ? (
                                    <a 
                                      href={`https://etsy.com/listing/${this.state.currentAlbumInfo.metadata.original_listing_id}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-decoration-none"
                                      title={`View original listing ${this.state.currentAlbumInfo.metadata.original_listing_id} on Etsy`}
                                    >
                                      <Badge bg="info" className="px-3 py-2" style={{ fontSize: '0.9em', cursor: 'pointer' }}>
                                        <i className="fas fa-external-link-alt me-1"></i>
                                        {this.state.currentAlbumInfo.metadata.original_listing_id}
                                      </Badge>
                                    </a>
                                  ) : (
                                    <span className="text-muted">
                                      <i className="fas fa-minus-circle me-1"></i>
                                      Chưa có
                                    </span>
                                  )}
                                </div>
                              </div>
                            </Col>
                            <Col md="3">
                              <div className="text-center">
                                <div className="text-muted small mb-2">
                                  <i className="fas fa-tag text-primary me-1"></i>
                                  Posted Listing
                                </div>
                                <div>
                                  {this.state.currentAlbumInfo.metadata?.posted_listing_id ? (
                                    <a 
                                      href={`https://etsy.com/listing/${this.state.currentAlbumInfo.metadata.posted_listing_id}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-decoration-none"
                                      title={`View posted listing ${this.state.currentAlbumInfo.metadata.posted_listing_id} on Etsy`}
                                    >
                                      <Badge bg="primary" className="px-3 py-2" style={{ fontSize: '0.9em', cursor: 'pointer' }}>
                                        <i className="fas fa-external-link-alt me-1"></i>
                                        {this.state.currentAlbumInfo.metadata.posted_listing_id}
                                      </Badge>
                                    </a>
                                  ) : (
                                    <span className="text-muted">
                                      <i className="fas fa-minus-circle me-1"></i>
                                      Chưa có
                                    </span>
                                  )}
                                </div>
                              </div>
                            </Col>
                          </>
                        )}
                        
                        {/* Show Shop for LISTING, BACKGROUND, DECORATING types */}
                        {(this.state.currentAlbumInfo.type === 'LISTING' || 
                          this.state.currentAlbumInfo.type === 'BACKGROUND' || 
                          this.state.currentAlbumInfo.type === 'DECORATING') && (
                          <Col md={this.state.currentAlbumInfo.type === 'LISTING' ? '6' : '12'}>
                            <div className="text-center">
                              <div className="text-muted small mb-2">
                                <i className="fas fa-store text-success me-1"></i>
                                Shop
                              </div>
                              <div>
                                {this.state.currentAlbumInfo.metadata?.registered_shop_mid ? (
                                  <a 
                                    href={`https://etsy.com/shop/${this.getShopNameFromMid(this.state.currentAlbumInfo.metadata.registered_shop_mid)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-decoration-none"
                                    title={`View shop ${this.getShopNameFromMid(this.state.currentAlbumInfo.metadata.registered_shop_mid)} on Etsy`}
                                  >
                                    <Badge bg="success" className="px-3 py-2" style={{ fontSize: '0.9em', cursor: 'pointer' }}>
                                      <i className="fas fa-external-link-alt me-1"></i>
                                      {this.state.currentAlbumInfo.metadata.registered_shop_mid} - {this.getShopNameFromMid(this.state.currentAlbumInfo.metadata.registered_shop_mid)}
                                    </Badge>
                                  </a>
                                ) : (
                                  <span className="text-muted">
                                    <i className="fas fa-minus-circle me-1"></i>
                                    Chưa có
                                  </span>
                                )}
                              </div>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </div>
                  ) : null}
                </div>
              )}
            </Col>
          </Row>
          
          {/* Album Description - Only show in album route when description exists */}
          {this.getRouteType() === 'ALBUM' && this.state.currentAlbumInfo && this.state.currentAlbumInfo.description && (
            <Row className="mb-3">
              <Col>
                <div className="bg-light p-3 rounded">
                  <p className="mb-0">
                    {this.state.currentAlbumInfo.description}
                  </p>
                </div>
              </Col>
            </Row>
          )}
          
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.props.totalCount}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <div className="d-flex align-items-center gap-2">
                  <small className="text-muted">
                    <FaUpload className="me-1" />
                    Hoặc kéo thả file vào trang
                  </small>
                <Button 
                  variant="success" 
                  size="sm"
                  onClick={this.handleOpenUploadModal}
                >
                  <FaUpload className="me-1" /> Upload Files
                </Button>
                </div>
                <Button 
                  variant="secondary" 
                  size="sm"
                  className="me-2"
                  onClick={() => this.setState({ showConfigModal: true })}
                >
                  <i className="fas fa-cog"></i> Cấu hình hiển thị
                </Button>
                <div className="btn-group me-2" role="group">
                  <Button
                    variant={this.state.viewMode === 'list' ? 'primary' : 'outline-secondary'}
                    size="sm"
                    onClick={() => this.handleViewModeToggle('list')}
                    title="Chế độ danh sách"
                  >
                    <FaList />
                  </Button>
                  <Button
                    variant={this.state.viewMode === 'grid' ? 'primary' : 'outline-secondary'}
                    size="sm"
                    onClick={() => this.handleViewModeToggle('grid')}
                    title="Chế độ lưới"
                  >
                    <FaTh />
                  </Button>
                </div>
                {this.state.viewMode === 'grid' && (
                  <div className="btn-group me-2" role="group">
                    <Button
                      variant={this.state.gridSize === 4 ? 'primary' : 'outline-secondary'}
                      size="sm"
                      onClick={() => this.handleGridSizeToggle(4)}
                      title="4 items per row"
                    >
                      <FaThLarge />
                    </Button>
                    <Button
                      variant={this.state.gridSize === 6 ? 'primary' : 'outline-secondary'}
                      size="sm"
                      onClick={() => this.handleGridSizeToggle(6)}
                      title="6 items per row"
                    >
                      <FaThList />
                    </Button>
                  </div>
                )}
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số bản ghi/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={this.handleChangeItemsPerPage}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={200}>200</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {this.state.viewMode === 'list' ? this.renderFileUploadTable() : this.renderFileUploadGrid()}
            </Col>
          </Row>
        </Container>
        
        {/* Drag and Drop Overlay */}
        {this.state.isDragOver && !this.state.uploadProgress.isUploading && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 123, 255, 0.1)',
              border: '3px dashed #007bff',
              zIndex: 9999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none'
            }}
          >
            <div
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                padding: '40px',
                borderRadius: '15px',
                textAlign: 'center',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
                border: '2px solid #007bff'
              }}
            >
              <FaUpload size={60} color="#007bff" style={{ marginBottom: '20px' }} />
              <h3 style={{ color: '#007bff', marginBottom: '10px' }}>
                Thả file để upload
              </h3>
              <p style={{ color: '#6c757d', margin: 0 }}>
                Kéo thả file vào đây để bắt đầu upload
              </p>
            </div>
          </div>
        )}

        {/* Upload Progress Overlay */}
        {this.state.uploadProgress.isUploading && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              zIndex: 9999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none'
            }}
          >
            <div
              style={{
                backgroundColor: 'white',
                padding: '40px',
                borderRadius: '15px',
                textAlign: 'center',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
                border: '2px solid #28a745',
                minWidth: '400px'
              }}
            >
              <FaUpload size={60} color="#28a745" style={{ marginBottom: '20px' }} />
              <h3 style={{ color: '#28a745', marginBottom: '20px' }}>
                Đang upload files...
              </h3>
              
              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="text-muted">Tiến độ:</span>
                  <span className="badge bg-primary">
                    {this.state.uploadProgress.current} / {this.state.uploadProgress.total}
                  </span>
                </div>
                <div className="progress" style={{ height: '25px' }}>
                  <div 
                    className="progress-bar progress-bar-striped progress-bar-animated bg-success" 
                    role="progressbar" 
                    style={{ 
                      width: `${(this.state.uploadProgress.current / this.state.uploadProgress.total) * 100}%` 
                    }}
                    aria-valuenow={this.state.uploadProgress.current} 
                    aria-valuemin="0" 
                    aria-valuemax={this.state.uploadProgress.total}
                  >
                    {Math.round((this.state.uploadProgress.current / this.state.uploadProgress.total) * 100)}%
                  </div>
                </div>
              </div>
              
              <div className="mb-3">
                <small className="text-muted">
                  <i className="fas fa-file me-1"></i>
                  Đang upload: <strong>{this.state.uploadProgress.currentFileName}</strong>
                </small>
              </div>
              
              <p style={{ color: '#6c757d', margin: 0, fontSize: '14px' }}>
                Vui lòng đợi trong khi files đang được upload...
              </p>
            </div>
          </div>
        )}
        
        <Pagination 
          totalItems={this.props.totalCount} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Configuration Modal */}
        <Modal show={this.state.showConfigModal} onHide={() => this.setState({ showConfigModal: false })} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Cấu hình hiển thị</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {/* Mode Selection */}
              <div className="mb-4">
                <h6 className="text-primary">Chọn chế độ cấu hình</h6>
                <div className="btn-group w-100" role="group">
                  <Button
                    variant={this.state.configMode === 'list' ? 'primary' : 'outline-secondary'}
                    onClick={() => this.setState({ configMode: 'list' })}
                  >
                    <FaList className="me-2" />
                    Cấu hình List View
                  </Button>
                  <Button
                    variant={this.state.configMode === 'grid' ? 'primary' : 'outline-secondary'}
                    onClick={() => this.setState({ configMode: 'grid' })}
                  >
                    <FaTh className="me-2" />
                    Cấu hình Grid View
                  </Button>
                </div>
              </div>
              
              <hr />
              
              {/* Column Configuration */}
              <div className="mb-3">
                <h6>
                  Hiển thị cột cho <strong>{this.state.configMode === 'list' ? 'List View' : 'Grid View'}</strong>
                </h6>
                <div className="row">
                  {Object.entries(this.state.showColumns[this.state.configMode] || {}).map(([column, isVisible]) => {
                  const columnLabels = {
                      original_filename: 'Tên file gốc',
                      filename: 'Tên file',
                    type: 'Loại',
                    file_size: 'Kích thước',
                    mime_type: 'MIME Type',
                    username: 'Username',
                    upload_date: 'Ngày tải lên',
                    upload_method: 'Phương thức',
                    status: 'Trạng thái',
                    is_public: 'Công khai',
                    bucket_name: 'Bucket',
                    file_url: 'Đường dẫn',
                      thumbnail_url: 'Thumbnail',
                    ref_id: 'Ref ID',
                    ref_type: 'Ref Type',
                    metadata: 'Metadata',
                    note: 'Ghi chú',
                    _id: 'ID'
                  };
                  
                  return (
                      <div key={column} className="col-md-6 col-lg-4">
                    <Form.Check
                      type="switch"
                          id={`column-${this.state.configMode}-${column}`}
                      label={columnLabels[column] || column}
                      checked={isVisible}
                      onChange={() => this.handleColumnToggle(column)}
                      className="mb-2"
                    />
                      </div>
                  );
                })}
                </div>
              </div>
              
              {/* Info */}
              <div className="alert alert-info">
                <i className="fas fa-info-circle me-2"></i>
                <strong>Lưu ý:</strong> Cấu hình được lưu riêng cho từng chế độ xem. 
                {this.state.configMode === 'list' 
                  ? ' List View hiển thị tất cả thông tin chi tiết trong bảng.' 
                  : ' Grid View hiển thị thông tin cơ bản trong card layout.'
                }
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfigModal: false })}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Modal */}
        <Modal show={this.state.showViewModal} onHide={this.handleCloseViewModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thông tin File Upload</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedFileUpload && (
              <div>
                {/* Basic Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin cơ bản</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Tên file gốc:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      {this.getFileIcon(this.state.selectedFileUpload.type)}
                      <span>{this.state.selectedFileUpload.original_filename}</span>
                      <FaCopy 
                        size={14} 
                        style={{ cursor: 'pointer', color: '#6c757d' }}
                        onClick={() => this.copyToClipboard(this.state.selectedFileUpload.original_filename)}
                        title="Copy tên file gốc"
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Tên file:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedFileUpload.filename || this.state.selectedFileUpload.original_filename}</span>
                      <FaCopy 
                        size={14} 
                        style={{ cursor: 'pointer', color: '#6c757d' }}
                        onClick={() => this.copyToClipboard(this.state.selectedFileUpload.filename || this.state.selectedFileUpload.original_filename)}
                        title="Copy tên file"
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Loại:</strong> 
                    <div className="mt-1">
                      {this.state.selectedFileUpload.type ? (
                        <Badge 
                          bg={
                            this.state.selectedFileUpload.type === 'IMAGE' ? 'primary' :
                            this.state.selectedFileUpload.type === 'VIDEO' ? 'danger' :
                            this.state.selectedFileUpload.type === 'PDF' ? 'danger' :
                            this.state.selectedFileUpload.type === 'DOC' || this.state.selectedFileUpload.type === 'DOCX' ? 'info' :
                            this.state.selectedFileUpload.type === 'XLS' || this.state.selectedFileUpload.type === 'XLSX' ? 'success' :
                            this.state.selectedFileUpload.type === 'PPT' || this.state.selectedFileUpload.type === 'PPTX' ? 'warning' :
                            this.state.selectedFileUpload.type === 'ZIP' || this.state.selectedFileUpload.type === 'RAR' ? 'secondary' :
                            'dark'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapType(this.state.selectedFileUpload.type)}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Kích thước:</strong> 
                    <div className="mt-1">
                      {this.formatFileSize(this.state.selectedFileUpload.file_size)}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>MIME Type:</strong> 
                    <div className="mt-1">
                      {this.state.selectedFileUpload.mime_type || '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Username:</strong> 
                    <div className="mt-1">
                      {this.state.selectedFileUpload.username ? (
                        <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                          {this.state.selectedFileUpload.username}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ngày tải lên:</strong> 
                    <div className="mt-1">
                      {this.state.selectedFileUpload.upload_date ? 
                        new Date(this.state.selectedFileUpload.upload_date).toLocaleString('vi-VN', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit'
                        }) : 
                        '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Upload Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin tải lên</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Phương thức:</strong> 
                    <div className="mt-1">
                      {this.state.selectedFileUpload.upload_method ? (
                        <Badge 
                          bg={
                            this.state.selectedFileUpload.upload_method === 'DIRECT' ? 'primary' :
                            this.state.selectedFileUpload.upload_method === 'BASE64' ? 'success' :
                            this.state.selectedFileUpload.upload_method === 'PRESIGNED_URL' ? 'info' :
                            this.state.selectedFileUpload.upload_method === 'MULTIPART' ? 'warning' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.state.selectedFileUpload.upload_method}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Trạng thái:</strong> 
                    <div className="mt-1">
                      {this.state.selectedFileUpload.status ? (
                        <Badge 
                          bg={
                            this.state.selectedFileUpload.status === 'UPLOADED' ? 'success' :
                            this.state.selectedFileUpload.status === 'UPLOADING' ? 'warning' :
                            this.state.selectedFileUpload.status === 'PROCESSING' ? 'info' :
                            this.state.selectedFileUpload.status === 'PROCESSED' ? 'primary' :
                            this.state.selectedFileUpload.status === 'FAILED' ? 'danger' :
                            this.state.selectedFileUpload.status === 'DELETED' ? 'dark' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(this.state.selectedFileUpload.status)}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Công khai:</strong> 
                    <div className="mt-1">
                      {this.state.selectedFileUpload.is_public ? (
                        <Badge bg="success" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                          Công khai
                        </Badge>
                      ) : (
                        <Badge bg="secondary" style={{ fontSize: '0.8em', padding: '4px 8px' }}>
                          Riêng tư
                        </Badge>
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Bucket:</strong> 
                    <div className="mt-1">
                      {this.state.selectedFileUpload.bucket_name || '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Reference Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin tham chiếu</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ref ID:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedFileUpload.ref_id || '-'}</span>
                      {this.state.selectedFileUpload.ref_id && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedFileUpload.ref_id)}
                          title="Copy Ref ID"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ref Type:</strong> 
                    <div className="mt-1">
                      {this.state.selectedFileUpload.ref_type || '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Additional Information */}
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Đường dẫn file:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span 
                        className="text-primary" 
                        style={{ 
                          fontSize: '0.9em', 
                          wordBreak: 'break-all',
                          cursor: 'pointer'
                        }}
                        onClick={() => window.open(this.getFileUrl(this.state.selectedFileUpload.s3_key, this.state.selectedFileUpload.is_public), '_blank')}
                        title="Click để mở file"
                      >
                        {this.getFileUrl(this.state.selectedFileUpload.s3_key, this.state.selectedFileUpload.is_public) || '-'}
                      </span>
                      {this.state.selectedFileUpload.s3_key && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.getFileUrl(this.state.selectedFileUpload.s3_key, this.state.selectedFileUpload.is_public))}
                          title="Copy URL"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                
                {(this.isMediaFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type) || this.isSvgFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type, this.state.selectedFileUpload.original_filename)) && (
                  <Row className="mb-3">
                    <Col md="12">
                      <strong>Preview {this.isVideoFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type) ? 'Video' : (this.isSvgFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type, this.state.selectedFileUpload.original_filename) ? 'SVG' : 'Ảnh')}:</strong> 
                      <div className="mt-2">
                        {this.isVideoFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type) ? (
                          <video 
                            src={this.getFileUrl(this.state.selectedFileUpload.s3_key, this.state.selectedFileUpload.is_public)}
                            controls
                            style={{ 
                              maxWidth: '100%', 
                              maxHeight: '300px', 
                              border: '1px solid #dee2e6',
                              borderRadius: '8px',
                              backgroundColor: '#000',
                              cursor: 'pointer'
                            }}
                            onClick={() => this.handleImageClick(this.state.selectedFileUpload)}
                            onError={(e) => {
                              e.target.style.display = 'none';
                              e.target.nextSibling.style.display = 'block';
                            }}
                          >
                            Trình duyệt của bạn không hỗ trợ video tag.
                          </video>
                        ) : (
                          <>
                            {/* For SVG files, always show original file directly */}
                            {this.isSvgFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type, this.state.selectedFileUpload.original_filename) ? (
                              <img 
                                src={this.getFileUrl(this.state.selectedFileUpload.s3_key, this.state.selectedFileUpload.is_public)} 
                                alt={this.state.selectedFileUpload.original_filename}
                                style={{ 
                                  maxWidth: '100%', 
                                  maxHeight: '300px', 
                                  objectFit: 'contain',
                                  border: '1px solid #dee2e6',
                                  borderRadius: '8px',
                                  padding: '10px',
                                  backgroundColor: '#f8f9fa',
                                  cursor: 'pointer'
                                }}
                                onClick={() => this.handleImageClick(this.state.selectedFileUpload)}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  e.target.nextSibling.style.display = 'block';
                                }}
                              />
                            ) : this.state.selectedFileUpload.thumbnail_s3_key ? (
                              <img 
                                src={this.getThumbnailUrl(this.state.selectedFileUpload.thumbnail_s3_key, this.state.selectedFileUpload.is_public)} 
                                alt={`Thumbnail of ${this.state.selectedFileUpload.original_filename}`}
                                style={{ 
                                  maxWidth: '100%', 
                                  maxHeight: '300px', 
                                  objectFit: 'contain',
                                  border: '1px solid #dee2e6',
                                  borderRadius: '8px',
                                  padding: '10px',
                                  backgroundColor: '#f8f9fa',
                                  cursor: 'pointer'
                                }}
                                onClick={() => this.handleImageClick(this.state.selectedFileUpload)}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  e.target.nextSibling.style.display = 'block';
                                }}
                              />
                            ) : (
                              <img 
                                src={this.getFileUrl(this.state.selectedFileUpload.s3_key, this.state.selectedFileUpload.is_public)} 
                                alt={this.state.selectedFileUpload.original_filename}
                                style={{ 
                                  maxWidth: '100%', 
                                  maxHeight: '300px', 
                                  objectFit: 'contain',
                                  border: '1px solid #dee2e6',
                                  borderRadius: '8px',
                                  padding: '10px',
                                  backgroundColor: '#f8f9fa',
                                  cursor: 'pointer'
                                }}
                                onClick={() => this.handleImageClick(this.state.selectedFileUpload)}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  e.target.nextSibling.style.display = 'block';
                                }}
                              />
                            )}
                          </>
                        )}
                        <div 
                          style={{ 
                            display: 'none',
                            padding: '20px',
                            textAlign: 'center',
                            color: '#6c757d',
                            border: '1px solid #dee2e6',
                            borderRadius: '8px',
                            backgroundColor: '#f8f9fa'
                          }}
                        >
                          <i className={`fas ${this.isVideoFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type) ? 'fa-video' : (this.isSvgFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type, this.state.selectedFileUpload.original_filename) ? 'fa-code' : 'fa-image')} fa-2x mb-2`}></i>
                          <div>Không thể hiển thị {this.isVideoFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type) ? 'video' : (this.isSvgFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type, this.state.selectedFileUpload.original_filename) ? 'SVG' : 'ảnh')}</div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                )}
                
                <Row className="mb-3">
                  <Col md="12">
                    <strong>S3 Key:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span style={{ fontSize: '0.9em', wordBreak: 'break-all' }}>
                        {this.state.selectedFileUpload.s3_key || '-'}
                      </span>
                      {this.state.selectedFileUpload.s3_key && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedFileUpload.s3_key)}
                          title="Copy S3 Key"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Metadata:</strong> 
                    <div className="mt-1">
                      {this.state.selectedFileUpload.metadata ? (
                        <div className="d-flex align-items-start gap-2">
                          <pre 
                            style={{ 
                              fontSize: '0.8em',
                              backgroundColor: '#f8f9fa',
                              padding: '10px',
                              borderRadius: '4px',
                              border: '1px solid #dee2e6',
                              maxHeight: '200px',
                              overflow: 'auto',
                              margin: 0,
                              flex: 1
                            }}
                          >
                            {JSON.stringify(this.state.selectedFileUpload.metadata, null, 2)}
                          </pre>
                          <FaCopy 
                            size={14} 
                            style={{ cursor: 'pointer', color: '#6c757d', marginTop: '5px' }}
                            onClick={() => this.copyToClipboard(JSON.stringify(this.state.selectedFileUpload.metadata, null, 2))}
                            title="Copy metadata"
                          />
                        </div>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Ghi chú:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedFileUpload.note || '-'}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseViewModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal show={this.state.showEditModal} onHide={this.handleCloseEditModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Chỉnh sửa File Upload</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Tên file</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.filename}
                      onChange={(e) => this.handleEditInputChange('filename', e.target.value)}
                      placeholder="Nhập tên file"
                    />
                    <Form.Text className="text-muted">
                      Tên file hiển thị (để trống để giữ tên gốc)
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleEditInputChange('status', e.target.value)}
                    >
                      <option value="UPLOADING">Đang tải lên</option>
                      <option value="UPLOADED">Đã tải lên</option>
                      <option value="PROCESSING">Đang xử lý</option>
                      <option value="PROCESSED">Đã xử lý</option>
                      <option value="FAILED">Thất bại</option>
                      <option value="DELETED">Đã xóa</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Công khai</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.is_public}
                      onChange={(e) => this.handleEditInputChange('is_public', e.target.value === 'true')}
                    >
                      <option value={false}>Riêng tư</option>
                      <option value={true}>Công khai</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ref ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ref_id}
                      onChange={(e) => this.handleEditInputChange('ref_id', e.target.value)}
                      placeholder="Nhập Ref ID"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ref Type</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ref_type}
                      onChange={(e) => this.handleEditInputChange('ref_type', e.target.value)}
                      placeholder="Nhập Ref Type"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Metadata (JSON format)</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      value={this.state.editFormData.metadata}
                      onChange={(e) => this.handleEditInputChange('metadata', e.target.value)}
                      placeholder='{"key": "value", "description": "example"}'
                    />
                    <Form.Text className="text-muted">
                      Nhập metadata dưới dạng JSON hợp lệ
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.note}
                      onChange={(e) => this.handleEditInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEditModal}>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveEdit}>
              Lưu thay đổi
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Upload Modal */}
        <Modal show={this.state.showUploadModal} onHide={this.handleCloseUploadModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              <FaUpload className="me-2" />
              Upload Files
              {this.getRouteType() === 'ALBUM' && this.getAlbumMid() && (
                <span className="text-muted ms-2">
                  (Album: {this.getAlbumMid()})
                </span>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* Album Info Alert */}
            {this.getRouteType() === 'ALBUM' && this.getAlbumMid() && (
              <div className="alert alert-info mb-4">
                <i className="fas fa-info-circle me-2"></i>
                <strong>Thông tin Album:</strong> Files upload sẽ được tự động thêm vào album <strong>{this.getAlbumMid()}</strong>
              </div>
            )}
            
            {this.shouldShowUploadTypeSelection() && (
              <div className="mb-4">
                <h6 className="text-primary">Chọn loại upload</h6>
                <hr />
                <Row>
                  <Col md="6">
                    <div 
                      className={`border rounded p-4 text-center cursor-pointer transition-all ${this.state.uploadIsPublic ? 'border-primary bg-primary text-white shadow-lg' : 'border-secondary bg-white hover:border-primary hover:bg-light'}`}
                      onClick={() => this.handleUploadTypeChange(true)}
                      style={{ 
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        transform: this.state.uploadIsPublic ? 'scale(1.02)' : 'scale(1)'
                      }}
                    >
                      <i className={`fas fa-globe fa-3x mb-3 ${this.state.uploadIsPublic ? 'text-white' : 'text-primary'}`}></i>
                      <h5 className={`mb-2 ${this.state.uploadIsPublic ? 'text-white' : 'text-dark'}`}>
                        Public Upload
                        {this.state.uploadIsPublic && <i className="fas fa-check-circle ms-2"></i>}
                      </h5>
                      <p className={`small mb-0 ${this.state.uploadIsPublic ? 'text-white-50' : 'text-muted'}`}>
                        Files sẽ được lưu trong bucket public và có thể truy cập công khai
                      </p>
                    </div>
                  </Col>
                  <Col md="6">
                    <div 
                      className={`border rounded p-4 text-center cursor-pointer transition-all ${!this.state.uploadIsPublic ? 'border-primary bg-primary text-white shadow-lg' : 'border-secondary bg-white hover:border-primary hover:bg-light'}`}
                      onClick={() => this.handleUploadTypeChange(false)}
                      style={{ 
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        transform: !this.state.uploadIsPublic ? 'scale(1.02)' : 'scale(1)'
                      }}
                    >
                      <i className={`fas fa-lock fa-3x mb-3 ${!this.state.uploadIsPublic ? 'text-white' : 'text-secondary'}`}></i>
                      <h5 className={`mb-2 ${!this.state.uploadIsPublic ? 'text-white' : 'text-dark'}`}>
                        Private Upload
                        {!this.state.uploadIsPublic && <i className="fas fa-check-circle ms-2"></i>}
                      </h5>
                      <p className={`small mb-0 ${!this.state.uploadIsPublic ? 'text-white-50' : 'text-muted'}`}>
                        Files sẽ được lưu trong bucket private và cần xác thực để truy cập
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            )}
            
            {!this.shouldShowUploadTypeSelection() && (() => {
              const routeType = this.getRouteType();
              const ornamentRoutes = ['ONM_SHAPE', 'ONM_OBJECT', 'ONM_IMAGE'];
              const isOrnamentRoute = ornamentRoutes.includes(routeType);
              const isPublic = isOrnamentRoute ? true : this.shouldUploadBePublic();
              
              return (
                <div className="mb-4">
                  <div className={`alert ${isPublic ? 'alert-success' : 'alert-warning'} d-flex align-items-center`}>
                    <i className={`fas ${isPublic ? 'fa-globe' : 'fa-lock'} me-2`}></i>
                    <div>
                      <strong>Upload Type:</strong> {isPublic ? 'Public' : 'Private'}
                      {isOrnamentRoute && <span className="badge bg-primary ms-2">Ornament Route (Forced)</span>}
                      <br />
                      <small>
                        {isPublic 
                          ? 'Files sẽ được lưu trong bucket public và có thể truy cập công khai'
                          : 'Files sẽ được lưu trong bucket private và cần xác thực để truy cập'
                        }
                        {isOrnamentRoute && ' - Ornament routes luôn upload public để đảm bảo tính nhất quán.'}
                      </small>
                    </div>
                  </div>
                </div>
              );
            })()}
            
            <div className="mb-3">
              <h6 className="text-primary">Upload Files</h6>
              <hr />
              <div className="border rounded p-3">
                <Form.Group>
                  <Form.Label>Chọn files để upload</Form.Label>
                  <Form.Control
                    type="file"
                    multiple
                    accept="image/*,video/*,.pdf,.doc,.docx,.txt,.json,.csv,.xls,.xlsx,.ppt,.pptx,.zip,.rar"
                    onChange={this.handleFileSelect}
                    className="mb-3"
                  />
                  <Form.Text className="text-muted">
                    Hỗ trợ: Images, Videos, PDF, Documents, Spreadsheets, Presentations, Archives (tối đa 20 files)
                  </Form.Text>
                </Form.Group>
                
                {this.state.selectedFiles && this.state.selectedFiles.length > 0 && (
                  <div className="mt-3">
                    <h6>Files đã chọn ({this.state.selectedFiles.length}):</h6>
                    <div className="row">
                      {this.state.selectedFiles.map((file, index) => {
                        const preview = this.state.filePreviews[index];
                        return (
                          <div key={index} className="col-md-6 mb-3">
                            <div className="border rounded p-3">
                              {preview && preview.url ? (
                                // Image preview
                                <div className="text-center">
                                  <img 
                                    src={preview.url} 
                                    alt={file.name}
                                    style={{ 
                                      maxWidth: '100%', 
                                      maxHeight: '150px', 
                                      objectFit: 'contain',
                                      borderRadius: '4px',
                                      border: '1px solid #dee2e6',
                                      marginBottom: '10px'
                                    }}
                                  />
                                  <div className="small fw-bold text-truncate mb-2" title={file.name}>
                                    {file.name}
                                  </div>
                                  <div className="small text-muted mb-2">
                                    {(file.size / 1024 / 1024).toFixed(2)} MB
                                  </div>
                                  <Form.Control
                                    type="text"
                                    size="sm"
                                    placeholder={file.name}
                                    value={this.state.customFilenames[index] || ''}
                                    onChange={(e) => this.handleFilenameChange(index, e.target.value)}
                                    className="mb-1"
                                  />
                                  <div className="small text-muted">
                                    Tùy chỉnh tên file (để trống để giữ tên gốc)
                                  </div>
                                </div>
                              ) : (
                                // Non-image file
                                <div>
                                  <div className="d-flex align-items-center mb-2">
                                    <i className={`fas fa-file me-3 ${this.getFileIconClass(file.type)} fa-2x`}></i>
                            <div className="flex-grow-1">
                                      <div className="small fw-bold text-truncate" title={file.name}>
                                        {file.name}
                                      </div>
                              <div className="small text-muted">
                                {(file.size / 1024 / 1024).toFixed(2)} MB
                              </div>
                            </div>
                          </div>
                                  <Form.Control
                                    type="text"
                                    size="sm"
                                    placeholder={file.name}
                                    value={this.state.customFilenames[index] || ''}
                                    onChange={(e) => this.handleFilenameChange(index, e.target.value)}
                                    className="mb-1"
                                  />
                                  <div className="small text-muted">
                                    Tùy chỉnh tên file (để trống để giữ tên gốc)
                        </div>
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                <div className="mt-3">
                  <Form.Group>
                    <Form.Label>Mô tả (tùy chọn)</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={this.state.uploadNote}
                      onChange={this.handleUploadNoteChange}
                      placeholder="Nhập mô tả cho files..."
                    />
                  </Form.Group>
                </div>

                <div className="mt-3">
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      id="createThumbnail"
                      label="Tạo thumbnail cho hình ảnh"
                      checked={this.state.createThumbnail}
                      onChange={this.handleThumbnailToggle}
                    />
                    <Form.Text className="text-muted">
                      Tự động tạo thumbnail cho các file hình ảnh (chỉ áp dụng cho file ảnh)
                    </Form.Text>
                  </Form.Group>
                </div>
                
                {/* Upload Progress */}
                {this.state.uploadProgress.isUploading && (
                  <div className="mt-3 p-3 bg-light rounded">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="mb-0 text-primary">
                        <i className="fas fa-upload me-2"></i>
                        Đang upload...
                      </h6>
                      <span className="badge bg-primary">
                        {this.state.uploadProgress.current} / {this.state.uploadProgress.total}
                      </span>
                    </div>
                    <div className="progress mb-2" style={{ height: '20px' }}>
                      <div 
                        className="progress-bar progress-bar-striped progress-bar-animated bg-primary" 
                        role="progressbar" 
                        style={{ 
                          width: `${(this.state.uploadProgress.current / this.state.uploadProgress.total) * 100}%` 
                        }}
                        aria-valuenow={this.state.uploadProgress.current} 
                        aria-valuemin="0" 
                        aria-valuemax={this.state.uploadProgress.total}
                      >
                        {Math.round((this.state.uploadProgress.current / this.state.uploadProgress.total) * 100)}%
                      </div>
                    </div>
                    <div className="text-center">
                      <small className="text-muted">
                        <i className="fas fa-file me-1"></i>
                        Đang upload: <strong>{this.state.uploadProgress.currentFileName}</strong>
                      </small>
                    </div>
                  </div>
                )}

                {this.state.selectedFiles && this.state.selectedFiles.length > 0 && (
                  <div className="text-center mt-3">
                    <Button
                      variant="primary"
                      onClick={this.handleUploadFiles}
                      disabled={this.state.uploadingFiles}
                    >
                      {this.state.uploadingFiles ? (
                        <>
                          <i className="fas fa-spinner fa-spin me-2"></i>
                          Đang upload...
                        </>
                      ) : (() => {
                        const routeType = this.getRouteType();
                        const ornamentRoutes = ['ONM_SHAPE', 'ONM_OBJECT', 'ONM_IMAGE'];
                        const isOrnamentRoute = ornamentRoutes.includes(routeType);
                        const displayIsPublic = isOrnamentRoute ? true : this.shouldUploadBePublic();
                        return (
                          <>
                            <FaUpload className="me-2" />
                            Upload {this.state.selectedFiles.length} Files ({displayIsPublic ? 'Public' : 'Private'})
                            {isOrnamentRoute && ' (Ornament)'}
                            {this.state.createThumbnail && ' + Thumbnail'}
                          </>
                        );
                      })()}
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseUploadModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Media Modal (for both images and videos) */}
        <Modal show={this.state.showImageModal} onHide={this.handleCloseImageModal} size="xl" centered>
          <Modal.Header closeButton>
            <div className="w-100">
              <Modal.Title>
                <i className={`fas ${this.state.selectedFileUpload && this.isVideoFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type) ? 'fa-video' : (this.state.selectedFileUpload && this.isSvgFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type, this.state.selectedFileUpload.original_filename) ? 'fa-code' : 'fa-image')} me-2`}></i>
                {this.state.selectedImageName}
                <span className="text-muted ms-2">
                  ({this.state.selectedImageIndex + 1} / {this.getMediaFiles().length})
                </span>
              </Modal.Title>
              <div className="text-muted small mt-1">
                <i className="fas fa-keyboard me-1"></i>
                Sử dụng phím mũi tên ← → để chuyển, ESC để đóng
              </div>
            </div>
          </Modal.Header>
          <Modal.Body className="text-center p-0 position-relative">
            {this.state.selectedImageUrl && this.state.selectedFileUpload && (
              <div style={{ 
                backgroundColor: '#000',
                minHeight: '400px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative'
              }}>
                {/* Previous Button */}
                {this.state.selectedImageIndex > 0 && (
                  <Button
                    variant="outline-light"
                    size="lg"
                    className="position-absolute start-0 top-50 translate-middle-y ms-3"
                    style={{ zIndex: 10 }}
                    onClick={this.handlePrevImage}
                    title="Trước"
                  >
                    <FaChevronLeft />
                  </Button>
                )}
                
                {/* Next Button */}
                {this.state.selectedImageIndex < this.getMediaFiles().length - 1 && (
                  <Button
                    variant="outline-light"
                    size="lg"
                    className="position-absolute end-0 top-50 translate-middle-y me-3"
                    style={{ zIndex: 10 }}
                    onClick={this.handleNextImage}
                    title="Tiếp theo"
                  >
                    <FaChevronRight />
                  </Button>
                )}
                
                {this.isVideoFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type) ? (
                  <video 
                    src={this.state.selectedImageUrl}
                    controls
                    autoPlay={false}
                    style={{ 
                      maxWidth: '100%', 
                      maxHeight: '80vh', 
                      borderRadius: '8px',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.5)'
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  >
                    Trình duyệt của bạn không hỗ trợ video tag.
                  </video>
                ) : this.isSvgFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type, this.state.selectedFileUpload.original_filename) ? (
                  <img 
                    src={this.state.selectedImageUrl}
                    alt={this.state.selectedImageName}
                    style={{ 
                      maxWidth: '100%', 
                      maxHeight: '80vh', 
                      objectFit: 'contain',
                      borderRadius: '8px',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                      backgroundColor: '#fff'
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                ) : (
                  <img 
                    src={this.getDisplayImageUrl()} 
                    alt={this.state.selectedImageName}
                    style={{ 
                      maxWidth: '100%', 
                      maxHeight: '80vh', 
                      objectFit: 'contain',
                      borderRadius: '8px',
                      boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                    }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                )}
                <div 
                  style={{ 
                    display: 'none',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '400px',
                    color: '#fff'
                  }}
                >
                  <i className={`fas ${this.state.selectedFileUpload && this.isVideoFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type) ? 'fa-video' : (this.state.selectedFileUpload && this.isSvgFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type, this.state.selectedFileUpload.original_filename) ? 'fa-code' : 'fa-image')} fa-4x mb-3`}></i>
                  <h5 className="text-white">Không thể hiển thị {this.state.selectedFileUpload && this.isVideoFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type) ? 'video' : (this.state.selectedFileUpload && this.isSvgFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type, this.state.selectedFileUpload.original_filename) ? 'SVG' : 'ảnh')}</h5>
                  <p className="text-white-50">Có thể file đã bị xóa hoặc không tồn tại</p>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between">
            <div>
              <Button 
                variant="outline-secondary" 
                size="sm"
                onClick={() => window.open(this.state.selectedImageUrl, '_blank')}
              >
                <i className="fas fa-external-link-alt me-1"></i>
                Mở trong tab mới
              </Button>
            </div>
            <div>
              <Button 
                variant="outline-primary" 
                size="sm"
                onClick={() => this.copyToClipboard(this.state.selectedImageUrl)}
                title={`Copy ${this.state.selectedFileUpload && this.isVideoFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type) ? 'video' : (this.state.selectedFileUpload && this.isSvgFile(this.state.selectedFileUpload.type, this.state.selectedFileUpload.mime_type, this.state.selectedFileUpload.original_filename) ? 'SVG' : 'image')} URL`}
              >
                <FaCopy className="me-1" />
                Copy URL
              </Button>
              <Button variant="secondary" onClick={this.handleCloseImageModal} className="ms-2">
                Đóng
              </Button>
            </div>
          </Modal.Footer>
        </Modal>

        {/* Album Selection Modal */}
        <Modal show={this.state.showAlbumSelectModal} onHide={this.handleCloseAlbumSelectModal} size="md">
          <Modal.Header closeButton>
            <Modal.Title>Thêm vào Album</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Nhập Album MID để thêm <strong>{this.state.selectedFileIds.length}</strong> file đã chọn:</p>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Album MID <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Nhập Album MID (ví dụ: ALBUM_001)"
                  value={this.state.albumMidInput || ''}
                  onChange={(e) => this.setState({ albumMidInput: e.target.value })}
                />
                <Form.Text className="text-muted">
                  Nhập MID của album mà bạn muốn thêm file vào
                </Form.Text>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseAlbumSelectModal}>
              Hủy
            </Button>
            <Button 
              variant="primary" 
              onClick={() => {
                const albumMid = this.state.albumMidInput?.trim();
                if (!albumMid) {
                  toast.error('Vui lòng nhập Album MID');
                  return;
                }
                this.handleAddFilesToAlbum(albumMid);
              }}
              disabled={!this.state.albumMidInput?.trim()}
              style={{ 
                minWidth: '120px',
                color: !this.state.albumMidInput?.trim() ? '#6c757d' : '#3472F7'
              }}
            >
              <i className="fas fa-plus me-1"></i>
              Thêm vào Album
            </Button>
          </Modal.Footer>
        </Modal>

        {/* All Albums Iframe Modal */}
        <IframeModal
          show={this.state.showAllAlbumsModal}
          onHide={this.handleCloseAllAlbumsModal}
          url="/admin/tkt1-media/album"
          title="Tất cả Albums"
          showSidebar={false}
        />

        {/* Album Edit Modal */}
        <Modal show={this.state.showAlbumEditModal} onHide={this.handleCloseAlbumEditModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Chỉnh sửa Album</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Tên album</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.albumEditFormData.name}
                      onChange={(e) => this.handleAlbumEditInputChange('name', e.target.value)}
                      placeholder="Nhập tên album"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>MID (Không thể chỉnh sửa)</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.albumEditFormData.mid}
                      disabled
                      className="bg-light"
                    />
                    <Form.Text className="text-muted">
                      MID được tạo tự động và không thể thay đổi
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Loại</Form.Label>
                    <Form.Select
                      value={this.state.albumEditFormData.type}
                      onChange={(e) => this.handleAlbumEditInputChange('type', e.target.value)}
                    >
                      <option value="LISTING">Listing</option>
                      <option value="AVATAR">Avatar</option>
                      <option value="C3D">C3D</option>
                      <option value="SCAN_PERSON">Scan Person</option>
                      <option value="OTHER_PUBLIC">Khác (Công khai)</option>
                      <option value="OTHER_PRIVATE">Khác (Riêng tư)</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.albumEditFormData.status}
                      onChange={(e) => this.handleAlbumEditInputChange('status', e.target.value)}
                      disabled={this.state.albumEditFormData.posted_listing_id && this.state.albumEditFormData.posted_listing_id.trim() !== ''}
                      className={this.state.albumEditFormData.posted_listing_id && this.state.albumEditFormData.posted_listing_id.trim() !== '' ? 'bg-light' : ''}
                    >
                      <option value="ACTIVE">Hoạt động</option>
                      <option value="INACTIVE">Không hoạt động</option>
                      <option value="DRAFT">Bản nháp</option>
                      <option value="PUBLISHED">Đã xuất bản</option>
                      <option value="ARCHIVED">Đã lưu trữ</option>
                      <option value="PENDING">Chờ duyệt</option>
                      <option value="REJECTED">Từ chối</option>
                    </Form.Select>
                    {this.state.albumEditFormData.posted_listing_id && this.state.albumEditFormData.posted_listing_id.trim() !== '' && (
                      <Form.Text className="text-muted">
                        <i className="fas fa-info-circle me-1"></i>
                        Trạng thái tự động là "Đã xuất bản" khi có Posted Listing ID
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Người tạo (Không thể chỉnh sửa)</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.albumEditFormData.username}
                      disabled
                      className="bg-light"
                    />
                    <Form.Text className="text-muted">
                      Username được tạo tự động và không thể thay đổi
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Tags</Form.Label>
                    <Form.Control
                      type="text"
                      value={Array.isArray(this.state.albumEditFormData.tags) ? this.state.albumEditFormData.tags.join(', ') : ''}
                      onChange={(e) => {
                        const tagsString = e.target.value;
                        const tagsArray = tagsString ? tagsString.split(',').map(tag => tag.trim()).filter(tag => tag) : [];
                        this.handleAlbumEditInputChange('tags', tagsArray);
                      }}
                      placeholder="Nhập tags, phân cách bằng dấu phẩy (ví dụ: tag1, tag2, tag3)"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              {/* Show Original Listing and Posted Listing only for LISTING type */}
              {this.state.currentAlbumInfo?.type === 'LISTING' && (
                <Row className="mb-3">
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Original Listing ID</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.albumEditFormData.original_listing_id}
                        onChange={(e) => this.handleAlbumEditInputChange('original_listing_id', e.target.value)}
                        placeholder="Nhập Original Listing ID"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Posted Listing ID</Form.Label>
                      <Form.Control
                        type="text"
                        value={this.state.albumEditFormData.posted_listing_id}
                        onChange={(e) => this.handleAlbumEditInputChange('posted_listing_id', e.target.value)}
                        placeholder="Nhập Posted Listing ID"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              )}
              
              {/* Show Shop for LISTING, BACKGROUND, DECORATING types */}
              {(this.state.currentAlbumInfo?.type === 'LISTING' || 
                this.state.currentAlbumInfo?.type === 'BACKGROUND' || 
                this.state.currentAlbumInfo?.type === 'DECORATING') && (
                <Row className="mb-3">
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Shop</Form.Label>
                      <Form.Select
                        value={this.state.albumEditFormData.registered_shop_mid}
                        onChange={(e) => this.handleAlbumEditInputChange('registered_shop_mid', e.target.value)}
                      >
                        <option value="">Chọn Shop</option>
                        {this.getRegisteredShopOptions().map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              )}
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Mô tả</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.albumEditFormData.description}
                      onChange={(e) => this.handleAlbumEditInputChange('description', e.target.value)}
                      placeholder="Nhập mô tả album"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={this.state.albumEditFormData.note}
                      onChange={(e) => this.handleAlbumEditInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseAlbumEditModal}>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveAlbumEdit}>
              Lưu thay đổi
            </Button>
          </Modal.Footer>
        </Modal>
        {this.state.showSVGSourceModal && (
          <Modal show={this.state.showSVGSourceModal} onHide={this.handleCloseSVGSourceModal} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                SVG Source File: {this.state.svgSourceFile?.filename || this.state.svgSourceFile?.original_filename}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.state.svgSourceFile && (
                <div className="mb-3">
                  <div><strong>Filename:</strong> {this.state.svgSourceFile.filename || this.state.svgSourceFile.original_filename}</div>
                  <div><strong>MIME Type:</strong> {this.state.svgSourceFile.mime_type}</div>
                  <div><strong>Size:</strong> {this.formatFileSize(this.state.svgSourceFile.file_size)}</div>
                  <div><strong>S3 Key:</strong> {this.state.svgSourceFile.s3_key}</div>
                </div>
              )}
              <div style={{marginBottom:24}}>
                <strong>SVG Source:</strong>
                <Button variant="light" className="ms-2" size="sm" onClick={() => {navigator.clipboard.writeText(this.state.currentSVGContent)}}>Sao chép</Button>
                <pre style={{ background: '#f8f8f8', padding: 12, maxHeight: 400, overflow: 'auto', border: '1px solid #eee', marginTop: 8 }}>{this.state.currentSVGContent}</pre>
                {/* preview SVG gốc nếu là SVG hợp lệ */}
                {this.state.currentSVGContent && this.state.currentSVGContent.startsWith('<svg') && (
                  <div className="my-3 text-center p-2 border bg-light">
                    <strong>Preview SVG Gốc:</strong>
                    <div style={{display:'block',margin:'10px auto',width: 100, height: 100, overflow: 'hidden', background: '#fff', border: '1px dashed #ccc'}}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: this.state.currentSVGContent.replace('<svg', '<svg style="width:100px; height:100px; display:block;"')
                        }}
                        style={{width:100, height:100, display:'block'}}
                      />
                    </div>
                  </div>
                )}
              </div>
              {/* SVG Normalized */}
              {this.state.svgSourceFile?.metadata?.normalizedSvgSource && (() => {
                let normalizedContent = '';
                try { normalizedContent = atob(this.state.svgSourceFile.metadata.normalizedSvgSource || ''); } catch(e) { normalizedContent = '-- Không decode được nội dung normalizedSvgSource --'; }
                return (
                  <div style={{marginBottom:24}}>
                    <strong>Normalized SVG Source:</strong>
                    <Button variant="light" className="ms-2" size="sm" onClick={() => {navigator.clipboard.writeText(normalizedContent)}}>Sao chép</Button>
                    <pre style={{ background: '#f8f8f8', padding: 12, maxHeight: 400, overflow: 'auto', border: '1px solid #eee', marginTop: 8 }}>{normalizedContent}</pre>
                    {this.state.svgSourceFile.metadata.normalizedSvgSource && (
                      <div className="my-3 text-center p-2 border bg-light">
                        <strong>Preview SVG Normalized:</strong>
                        <div style={{display:'block',margin:'10px auto',width: 120, height: 120, overflow: 'hidden', background: '#fff', border: '1px dashed #bbb'}}>
                          <img
                            src={`data:image/svg+xml;base64,${this.state.svgSourceFile.metadata.normalizedSvgSource}`}
                            alt="SVG Normalized Preview"
                            style={{width: 100, height: 100, objectFit:'contain', display:'block', background:'#fff', margin: "10px"}}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                );
              })()}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.handleCloseSVGSourceModal}>Đóng</Button>
            </Modal.Footer>
          </Modal>
        )}
      </>
    );
  }

  handleViewSVGSource = async (fileUpload) => {
    try {
      // Nếu có metadata.source_svg (base64), ưu tiên dùng
      const base64Content = fileUpload?.metadata?.source_svg;
      if (base64Content) {
        let decodedContent = '';
        try {
          decodedContent = atob(base64Content);
        } catch (err) {
          decodedContent = '-- Nội dung source_svg không hợp lệ base64! --';
        }
        this.setState({
          showSVGSourceModal: true,
          currentSVGContent: decodedContent,
          svgSourceFile: fileUpload,
        });
        return;
      }
      // Không có metadata.source_svg thì thử fetch từ S3 như cũ
      const s3Url = this.getFileUrl(fileUpload.s3_key, fileUpload.is_public);
      const res = await fetch(s3Url);
      if (!res.ok) {
        this.setState({
          showSVGSourceModal: true,
          currentSVGContent: `HTTP Error: ${res.status} - ${res.statusText}`,
          svgSourceFile: fileUpload,
        });
        return;
      }
      const text = await res.text();
      this.setState({
        showSVGSourceModal: true,
        currentSVGContent: text,
        svgSourceFile: fileUpload,
      });
    } catch (err) {
      this.setState({
        showSVGSourceModal: true,
        currentSVGContent: 'Không load được nội dung SVG! ' + (err?.message || ''),
        svgSourceFile: fileUpload,
      });
    }
  };

  handleCloseSVGSourceModal = () => {
    this.setState({ showSVGSourceModal: false, svgSourceFile: null, currentSVGContent: '' });
  };
}

const mapStateToProps = (state) => {
  return {
    fileUploads: state.tkt1FileUploadManagementReducer.fileUploads,
    totalCount: state.tkt1FileUploadManagementReducer.totalCount,
    currentUrl: state.tkt1FileUploadManagementReducer.currentUrl,
    albums: state.tkt1ImageAlbumReducer.albums,
    registeredEtsyShops: state.tkt1RegisteredEtsyShopReducer?.registeredEtsyShops || []
  };
};

export default connect(mapStateToProps, { getTKT1FileUploads, createTKT1FileUpload, updateTKT1FileUpload, deleteTKT1FileUpload, getTKT1ImageAlbums, getTKT1ImageAlbumByMID, updateTKT1ImageAlbum, getTKT1RegisteredEtsyShops })(TKT1FileUploadManagement);
